<template>
	<div :class="sideOverShow ? 'side-over--active' : ''">
		<div
			v-if="sideOverShow"
			class="
				fixed
				h-screen
				w-screen
				top-0
				left-0
				bg-black
				opacity-20
				z-30
			"
			@click="sideOverShow = false"
		></div>
		<Goal
			v-if="step === 1"
			@close="sideOverShow = false"
			@submit="submitNote"
			:sideOverShow="sideOverShow"
			:reportId="report?.id"
			:goalSelectedId="goalSelectedId"
		/>
		<NoteSlide
			v-if="step === 2"
			@close="sideOverShow = false"
			@submit="submitNoteContent"
			:noteContent="noteContent"
			:sideOverShow="sideOverShow"
		/>
	</div>
	<DaModalFrame v-model:open="modalIsOpen">
		<ConfirmSendMonthlyReport
			v-if="modalType === modalTypes.CREATE"
			:name="report.report_for_plan?.order"
			@close="cancelSendReport"
			@submit="sendReport"
		/>
		<ConfirmModal
			v-if="modalType === modalTypes.CONFIRM"
			v-model:data="reportData"
			v-model:success="successData"
			@close="cancelConfirm"
			@doNextPlan="doNextPlan"
			@submit="confirmSubmit"
			@close-complete="cancelConfirmCompleted"
		/>
		<CopyModal
			v-if="modalType === modalTypes.COPY"
			v-model:path="path"
			@close="closeShare"
		/>
		<ExitModal
			v-if="modalType === modalTypes.EXIT"
			@close="cancelConfirm"
			@submit="cancel"
		/>
		<ErrorModal
			v-if="modalType === modalTypes.ERROR"
			v-model:error="errorData"
			@close="cancelConfirm"
		/>
		<LoadingDowloadPDF
			v-if="modalType === modalTypes.LOADING"
			:text="'Đang tải xuống file PDF Báo cáo tháng'"
		/>
	</DaModalFrame>
	<div>
		<div v-if="!isLoading">
			<div
				:class="[editReport && step === 1 ? 'transition' : '']"
				class="
					__goal-management-student-detail
					p-10
					md-down:px-4
					content-report-is-hide
				"
			>
				<div class="flex justify-between items-center">
					<div
						class="
							__breadcrumbs
							text-sm text-neutral-500
							font-semibold
							flex-nowrap flex
							items-center
						"
					>
						<router-link
							:to="{
								path: is_old_data
									? '/transferred-data'
									: '/report/monthly-report',
							}"
						>
							{{
								is_old_data
									? 'Xem hồ sơ cũ'
									: 'Danh sách học sinh'
							}}
						</router-link>
						<div class="__breadcrumbs__decorate">
							<DaIcon
								class="transform -rotate-90 h-3 w-3 mx-2"
								name="das--chevron-down"
							/>
						</div>
						<div>Xem báo cáo</div>
					</div>
					<button
						v-if="is_old_data"
						class="
							button-p
							text-center
							w-fit
							btn--text
							text-neutral-500
							hover:text-neutral-600
						"
						type="button"
						@click="exit"
					>
						<svg
							class="mr-2 text-neutral-400"
							fill="none"
							height="16"
							viewBox="0 0 16 16"
							width="16"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M1.5 7.99996L0.719131 7.37526L0.219375 7.99996L0.719131 8.62465L1.5 7.99996ZM7.5 8.99996C8.05228 8.99996 8.5 8.55224 8.5 7.99996C8.5 7.44767 8.05228 6.99996 7.5 6.99996V8.99996ZM3.3858 4.04193L0.719131 7.37526L2.28087 8.62465L4.94754 5.29132L3.3858 4.04193ZM0.719131 8.62465L3.3858 11.958L4.94754 10.7086L2.28087 7.37526L0.719131 8.62465ZM1.5 8.99996H7.5V6.99996H1.5V8.99996Z"
								fill="currentColor"
							/>
							<path
								d="M7.78738 13.3439L8.31032 12.4915L7.78738 13.3439ZM6.97976 12.3905L6.05301 12.7662L6.97976 12.3905ZM14.499 12.5015L15.3875 12.9603L14.499 12.5015ZM12.7525 13.981L12.4461 13.0291L12.7525 13.981ZM14.499 3.49854L15.3875 3.0398L14.499 3.49854ZM13.8333 6.81921V9.18087H15.8333V6.81921H13.8333ZM7.83325 5.42133V5.29122H5.83325V5.42133H7.83325ZM9.58524 12.7782C8.62733 12.6186 8.43551 12.5683 8.31032 12.4915L7.26445 14.1962C7.80406 14.5273 8.47961 14.6216 9.25644 14.751L9.58524 12.7782ZM5.83325 10.7107C5.83325 11.4979 5.81518 12.1795 6.05301 12.7662L7.90651 12.0148C7.85132 11.8787 7.83325 11.6814 7.83325 10.7107H5.83325ZM8.31032 12.4915C8.12826 12.3798 7.98675 12.2128 7.90651 12.0148L6.05301 12.7662C6.29374 13.36 6.71828 13.8612 7.26445 14.1962L8.31032 12.4915ZM13.8333 9.18087C13.8333 10.0882 13.8325 10.7099 13.7946 11.1876C13.7573 11.6573 13.6894 11.8898 13.6104 12.0428L15.3875 12.9603C15.6428 12.4658 15.742 11.929 15.7883 11.3458C15.834 10.7705 15.8333 10.0557 15.8333 9.18087H13.8333ZM9.25644 14.751C10.1198 14.8949 10.8251 15.0132 11.4002 15.0628C11.9832 15.113 12.5291 15.1035 13.0589 14.9329L12.4461 13.0291C12.2822 13.0819 12.0416 13.1107 11.5719 13.0702C11.0943 13.029 10.4806 12.9275 9.58524 12.7782L9.25644 14.751ZM13.6104 12.0428C13.3679 12.5125 12.9493 12.8671 12.4461 13.0291L13.0589 14.9329C14.0653 14.609 14.9025 13.8997 15.3875 12.9603L13.6104 12.0428ZM9.58645 3.22163C10.4814 3.07248 11.0948 2.97099 11.5722 2.92986C12.0416 2.88942 12.2822 2.91819 12.4461 2.97096L13.0589 1.06717C12.5292 0.896646 11.9834 0.887021 11.4005 0.937243C10.8256 0.986778 10.1206 1.10503 9.25766 1.24885L9.58645 3.22163ZM15.8333 6.81921C15.8333 5.9444 15.834 5.22954 15.7883 4.65428C15.742 4.07104 15.6428 3.53429 15.3875 3.0398L13.6104 3.95728C13.6894 4.1103 13.7573 4.34283 13.7946 4.81252C13.8325 5.29019 13.8333 5.91191 13.8333 6.81921H15.8333ZM12.4461 2.97096C12.9493 3.13294 13.3679 3.48755 13.6104 3.95728L15.3875 3.0398C14.9025 2.10035 14.0653 1.39113 13.0589 1.06717L12.4461 2.97096ZM9.25766 1.24885C8.83685 1.31898 8.47124 1.37935 8.17099 1.45102C7.85987 1.52528 7.55473 1.62545 7.26252 1.80503L8.30967 3.50898C8.35038 3.48397 8.42887 3.44565 8.63532 3.39637C8.85265 3.3445 9.13857 3.29628 9.58645 3.22163L9.25766 1.24885ZM7.83325 5.29122C7.83325 4.83715 7.83381 4.5472 7.84925 4.3243C7.86391 4.11256 7.88881 4.02884 7.90679 3.98457L6.05387 3.23179C5.92477 3.54955 5.87613 3.86701 5.85403 4.1861C5.8327 4.49405 5.83325 4.86461 5.83325 5.29122H7.83325ZM7.26252 1.80503C6.71792 2.13971 6.29446 2.63958 6.05387 3.23179L7.90679 3.98457C7.98699 3.78717 8.12814 3.62054 8.30967 3.50898L7.26252 1.80503Z"
								fill="currentColor"
							/>
						</svg>
						Thoát
					</button>
					<button
						v-else-if="editReport"
						class="
							button-p
							text-center
							w-fit
							btn--text
							text-neutral-500
							hover:text-neutral-600
						"
						type="button"
						@click="exit"
					>
						<svg
							class="mr-2 text-neutral-400"
							fill="none"
							height="16"
							viewBox="0 0 16 16"
							width="16"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M1.5 7.99996L0.719131 7.37526L0.219375 7.99996L0.719131 8.62465L1.5 7.99996ZM7.5 8.99996C8.05228 8.99996 8.5 8.55224 8.5 7.99996C8.5 7.44767 8.05228 6.99996 7.5 6.99996V8.99996ZM3.3858 4.04193L0.719131 7.37526L2.28087 8.62465L4.94754 5.29132L3.3858 4.04193ZM0.719131 8.62465L3.3858 11.958L4.94754 10.7086L2.28087 7.37526L0.719131 8.62465ZM1.5 8.99996H7.5V6.99996H1.5V8.99996Z"
								fill="currentColor"
							/>
							<path
								d="M7.78738 13.3439L8.31032 12.4915L7.78738 13.3439ZM6.97976 12.3905L6.05301 12.7662L6.97976 12.3905ZM14.499 12.5015L15.3875 12.9603L14.499 12.5015ZM12.7525 13.981L12.4461 13.0291L12.7525 13.981ZM14.499 3.49854L15.3875 3.0398L14.499 3.49854ZM13.8333 6.81921V9.18087H15.8333V6.81921H13.8333ZM7.83325 5.42133V5.29122H5.83325V5.42133H7.83325ZM9.58524 12.7782C8.62733 12.6186 8.43551 12.5683 8.31032 12.4915L7.26445 14.1962C7.80406 14.5273 8.47961 14.6216 9.25644 14.751L9.58524 12.7782ZM5.83325 10.7107C5.83325 11.4979 5.81518 12.1795 6.05301 12.7662L7.90651 12.0148C7.85132 11.8787 7.83325 11.6814 7.83325 10.7107H5.83325ZM8.31032 12.4915C8.12826 12.3798 7.98675 12.2128 7.90651 12.0148L6.05301 12.7662C6.29374 13.36 6.71828 13.8612 7.26445 14.1962L8.31032 12.4915ZM13.8333 9.18087C13.8333 10.0882 13.8325 10.7099 13.7946 11.1876C13.7573 11.6573 13.6894 11.8898 13.6104 12.0428L15.3875 12.9603C15.6428 12.4658 15.742 11.929 15.7883 11.3458C15.834 10.7705 15.8333 10.0557 15.8333 9.18087H13.8333ZM9.25644 14.751C10.1198 14.8949 10.8251 15.0132 11.4002 15.0628C11.9832 15.113 12.5291 15.1035 13.0589 14.9329L12.4461 13.0291C12.2822 13.0819 12.0416 13.1107 11.5719 13.0702C11.0943 13.029 10.4806 12.9275 9.58524 12.7782L9.25644 14.751ZM13.6104 12.0428C13.3679 12.5125 12.9493 12.8671 12.4461 13.0291L13.0589 14.9329C14.0653 14.609 14.9025 13.8997 15.3875 12.9603L13.6104 12.0428ZM9.58645 3.22163C10.4814 3.07248 11.0948 2.97099 11.5722 2.92986C12.0416 2.88942 12.2822 2.91819 12.4461 2.97096L13.0589 1.06717C12.5292 0.896646 11.9834 0.887021 11.4005 0.937243C10.8256 0.986778 10.1206 1.10503 9.25766 1.24885L9.58645 3.22163ZM15.8333 6.81921C15.8333 5.9444 15.834 5.22954 15.7883 4.65428C15.742 4.07104 15.6428 3.53429 15.3875 3.0398L13.6104 3.95728C13.6894 4.1103 13.7573 4.34283 13.7946 4.81252C13.8325 5.29019 13.8333 5.91191 13.8333 6.81921H15.8333ZM12.4461 2.97096C12.9493 3.13294 13.3679 3.48755 13.6104 3.95728L15.3875 3.0398C14.9025 2.10035 14.0653 1.39113 13.0589 1.06717L12.4461 2.97096ZM9.25766 1.24885C8.83685 1.31898 8.47124 1.37935 8.17099 1.45102C7.85987 1.52528 7.55473 1.62545 7.26252 1.80503L8.30967 3.50898C8.35038 3.48397 8.42887 3.44565 8.63532 3.39637C8.85265 3.3445 9.13857 3.29628 9.58645 3.22163L9.25766 1.24885ZM7.83325 5.29122C7.83325 4.83715 7.83381 4.5472 7.84925 4.3243C7.86391 4.11256 7.88881 4.02884 7.90679 3.98457L6.05387 3.23179C5.92477 3.54955 5.87613 3.86701 5.85403 4.1861C5.8327 4.49405 5.83325 4.86461 5.83325 5.29122H7.83325ZM7.26252 1.80503C6.71792 2.13971 6.29446 2.63958 6.05387 3.23179L7.90679 3.98457C7.98699 3.78717 8.12814 3.62054 8.30967 3.50898L7.26252 1.80503Z"
								fill="currentColor"
							/>
						</svg>
						Thoát
					</button>
				</div>
				<div class="__goal-management-student-detail__header pt-5">
					<div
						class="
							flex
							justify-between
							items-center
							w-full
							md-down:flex-col md-down:items-start
						"
					>
						<router-link
							:to="`/record/student/${report?.student?.id}`"
						>
							<div class="flex items-center">
								<img
									v-if="report?.student?.profile_photo?.w200"
									:src="report?.student?.profile_photo?.w200"
									alt=""
									class="
										shadow-sm
										inline-block
										h-14
										w-14
										rounded-full
									"
									style="min-width: 56px"
								/>
								<span
									v-else
									:style="{
										background:
											report?.student?.profile_photo
												?.default?.color,
									}"
									class="
										inline-flex
										items-center
										justify-center
										h-14
										w-14
										rounded-full
									"
									style="min-width: 56px"
								>
									<span
										class="
											font-medium
											leading-none
											text-white text-4xl
										"
										>{{
											report?.student?.profile_photo
												?.default?.initial
										}}</span
									>
								</span>
								<div class="ml-4">
									<div
										class="
											font-bold
											text-neutral-700 text-4xl
											md-down:text-2xl
										"
									>
										{{ report?.student?.name }}
									</div>
									<div
										v-if="is_old_data && dateData"
										class="
											text-green-500
											font-semibold
											text-xs
											uppercase
											letter-spacing-8
										"
									>
										{{ dateData }}
									</div>
									<div
										v-else-if="report?.student?.age"
										class="
											text-green-500
											font-semibold
											text-xs
											uppercase
										"
									>
										{{ report?.student?.age }}
										{{
											report?.student?.learning_time
												? `| ${report?.student?.learning_time}`
												: ''
										}}
									</div>
								</div>
							</div>
						</router-link>
						<div class="md-down:mt-8 flex flex-wrap gap-4">
							<div
								v-if="!editReport && report && !report.sent_at"
							>
								<button
									class="
										button-p
										text-center
										whitespace-nowrap
										w-fit
									"
									type="button"
									@click="openSendConfirm"
								>
									Gửi tới phụ huynh
								</button>
							</div>
							<div
								v-if="editReport && (step === 2 || step === 3)"
								class="flex space-x-4"
							>
								<button
									v-if="step === 2"
									class="
										button-p
										text-center
										w-fit
										btn--ghost
									"
									type="button"
									@click="step = 1"
								>
									<svg
										class="mr-2"
										fill="none"
										height="16"
										viewBox="0 0 16 16"
										width="16"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											d="M10 4L6 8L10 12"
											stroke="#D89210"
											stroke-linecap="round"
											stroke-linejoin="round"
											stroke-width="2"
										/>
									</svg>
									Trở về bước 1
								</button>
								<button
									v-if="step === 3"
									class="
										button-p
										text-center
										w-fit
										btn--ghost
									"
									type="button"
									@click="step = 2"
								>
									<svg
										class="mr-2"
										fill="none"
										height="16"
										viewBox="0 0 16 16"
										width="16"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											d="M10 4L6 8L10 12"
											stroke="#D89210"
											stroke-linecap="round"
											stroke-linejoin="round"
											stroke-width="2"
										/>
									</svg>
									Trở về bước 2
								</button>
							</div>
							<!-- <div v-if="step === 1 && editReport">
								<button
									class="
										button-p
										text-center
										w-fit
										btn--ghost
									"
									type="button"
									@click="isMTShow = true"
								>
									Xem trước MT cần báo cáo
								</button>
							</div> -->
							<div
								v-show="step === 1 && editReport"
								class="md:hidden"
							>
								<button
									:disabled="!all_goals_reported"
									class="
										button-p
										text-center
										whitespace-nowrap
										w-fit
										md:hidden
									"
									type="button"
									@click="step = 2"
								>
									<svg
										class="mr-2"
										fill="none"
										height="10"
										viewBox="0 0 6 10"
										width="6"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											d="M1 9L5 5L1 1"
											stroke="currentColor"
											stroke-linecap="round"
											stroke-linejoin="round"
											stroke-width="2"
										/>
									</svg>
									Bước 2: Nhận xét chung
								</button>
							</div>
							<div
								v-show="
									step === 2 &&
									editReport &&
									report?.state !== 'completed'
								"
								class="md:hidden"
							>
								<button
									:disabled="!noteContent"
									class="
										button-p
										text-center
										whitespace-nowrap
										w-fit
									"
									type="button"
									@click="step = 3"
								>
									<svg
										class="mr-2"
										fill="none"
										height="10"
										viewBox="0 0 6 10"
										width="6"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											d="M1 9L5 5L1 1"
											stroke="currentColor"
											stroke-linecap="round"
											stroke-linejoin="round"
											stroke-width="2"
										/>
									</svg>
									Bước 3: Kế hoạch tiếp theo
								</button>
							</div>
							<div
								v-show="
									step === 2 &&
									editReport &&
									report?.state === 'completed'
								"
								class="md:hidden"
							>
								<button
									:disabled="!noteContent"
									class="
										button-p
										text-center
										whitespace-nowrap
										w-fit
									"
									type="button"
									@click="submit"
								>
									<svg
										class="mr-2"
										fill="none"
										height="10"
										viewBox="0 0 6 10"
										width="6"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											d="M1 9L5 5L1 1"
											stroke="currentColor"
											stroke-linecap="round"
											stroke-linejoin="round"
											stroke-width="2"
										/>
									</svg>
									Cập nhật báo cáo
								</button>
							</div>
						</div>
					</div>
				</div>
				<div v-show="step === 1 && editReport">
					<div class="relative mt-12">
						<div
							aria-hidden="true"
							class="absolute inset-0 flex items-center"
						>
							<div class="w-full border-t border-neutral-300" />
						</div>
						<div class="relative flex items-center justify-between">
							<span
								class="
									pr-3
									bg-body
									text-lg
									font-semibold
									text-neutral-600
									mb-2
								"
							>
								Bước 1: Nhận xét & đánh giá từng mục tiêu
							</span>
							<button
								:disabled="!all_goals_reported"
								class="
									button-p
									text-center
									whitespace-nowrap
									w-fit
									md-down:hidden
								"
								type="button"
								@click="step = 2"
							>
								<svg
									class="mr-2"
									fill="none"
									height="10"
									viewBox="0 0 6 10"
									width="6"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M1 9L5 5L1 1"
										stroke="currentColor"
										stroke-linecap="round"
										stroke-linejoin="round"
										stroke-width="2"
									/>
								</svg>
								Bước 2: Nhận xét chung
							</button>
						</div>
					</div>
					<div class="mt-8">
						<div
							v-for="(s, i) in listAssessment"
							:key="i"
							class="mb-8"
						>
							<div
								class="
									text-lg
									font-semibold
									text-neutral-600
									mb-4
								"
							>
								{{ i + 1 }}. {{ s?.name || s?.skill?.name }} ({{
									s?.goals.length
								}})
							</div>

							<table
								class="
									shadow-sm
									sm:rounded-2xl
									overflow-x-auto
									min-w-full
									divide-y
									text-neutral-200
									table-fixed
									w-full
								"
							>
								<thead class="bg-neutral-100 h-16">
									<tr>
										<th
											class="
												px-4
												py-3
												text-left text-xs
												font-semibold
												text-neutral-600
												uppercase
												tracking-wider
												whitespace-nowrap
												w-16
											"
											scope="col"
											style="width: 64px"
										>
											STT
										</th>
										<th
											class="
												px-6
												py-3
												text-left text-xs
												font-semibold
												text-neutral-600
												uppercase
												tracking-wider
											"
											scope="col"
											:class="{
												'w-custom': s.goals.some(
													(g) =>
														g?.assessment_report
															?.note
												),
											}"
											style="width: 300px"
										>
											Nội dung
										</th>
										<th
											class="
												px-6
												py-3
												text-left text-xs
												font-semibold
												text-neutral-600
												uppercase
												tracking-wider
												whitespace-nowrap
											"
											scope="col"
											style="width: 145px"
										>
											Kết quả
										</th>
										<th
											class="
												px-6
												py-3
												text-left text-xs
												font-semibold
												text-neutral-600
												uppercase
												tracking-wider
												whitespace-nowrap
											"
											scope="col"
											style="width: 270px"
										>
											Đánh giá
										</th>
										<th
											class="
												px-6
												py-3
												text-left text-xs
												font-semibold
												text-neutral-600
												uppercase
												tracking-wider
											"
											scope="col"
											:class="
												s.goals.some(
													(g) =>
														g?.assessment_report
															?.note
												)
													? 'w-custom'
													: 'w-186'
											"
										>
											Nhận xét
										</th>
									</tr>
								</thead>
								<tbody>
									<tr
										v-for="(g, index) in s.goals"
										:key="g?.goal_id || g?.id"
										:class="
											index % 2 === 0
												? 'bg-white'
												: 'bg-neutral-50'
										"
										class="
											text-neutral-700
											hover:bg-orange-50
											cursor-pointer
										"
									>
										<td
											class="
												px-4
												py-4
												whitespace-nowrap
												text-neutral-700 text-center
											"
										>
											{{ index + 1 }}
										</td>
										<td class="px-6 py-4 text-neutral-700">
											<div
												v-html="g?.goal_name || g?.name"
											></div>
											<div
												v-if="g?.parent"
												class="
													p-3
													py-2
													rounded-xl
													border
													mt-2
													flex
													gap-3
												"
												style="
													border: 1px solid #bacde4;
													background: #eef3f8;
												"
											>
												<div class="w-4">
													<svg
														fill="none"
														height="16"
														viewBox="0 0 16 16"
														width="16"
														xmlns="http://www.w3.org/2000/svg"
													>
														<path
															d="M2.66663 2.6665V8.6665C2.66663 9.37375 2.94758 10.052 3.44768 10.5521C3.94777 11.0522 4.62605 11.3332 5.33329 11.3332H11.3906L9.72396 12.9998L10.6666 13.9425L13.9426 10.6665L10.6666 7.3905L9.72396 8.33317L11.3906 9.99984H5.33329C4.97967 9.99984 4.64053 9.85936 4.39048 9.60931C4.14044 9.35926 3.99996 9.02013 3.99996 8.6665V2.6665H2.66663Z"
															fill="#94A3B8"
														/>
													</svg>
												</div>
												<div>
													<div
														class="
															whitespace-normal
														"
														v-html="
															g?.parent?.name ??
															g?.parent?.goal_name
														"
													></div>
													<div
														class="
															text-sm
															font-semibold
														"
														style="color: #94a3b8"
													>
														{{
															g?.parent
																?.sub_goal_count
														}}
														mục tiêu
													</div>
												</div>
											</div>
										</td>
										<td
											class="
												px-6
												py-4
												whitespace-nowrap
												text-neutral-700
											"
										>
											<div>
												<div
													v-if="
														g?.assessment_report
															?.complete_percent !==
														null
													"
													:style="{
														background:
															$filters.tagResult(
																g
																	?.assessment_report
																	?.complete_percent
															)?.background,
														color: $filters.tagResult(
															g?.assessment_report
																?.complete_percent
														)?.color,
													}"
													class="
														py-0.5
														px-2.5
														rounded-full
														text-neutral-700
														h-fit
														w-fit
														font-semibold
														text-sm
														shadow-input
													"
												>
													{{
														g?.assessment_report
															?.result
													}}
												</div>
												<div v-else>Chưa học</div>
											</div>
										</td>
										<td
											class="
												px-6
												py-4
												whitespace-nowrap
												text-neutral-700
											"
										>
											<div
												v-if="
													g.assessment_report
														?.next_plan
												"
											>
												{{
													g.assessment_report
														.next_plan
												}}
											</div>
											<div
												v-else
												class="luca-ai w-max"
												@click.stop="addNoteForGoal(g)"
											>
												Thêm đánh giá
											</div>
										</td>
										<td class="px-6 py-4 text-neutral-700">
											<div
												v-if="
													g?.assessment_report?.note
												"
												class="
													flex
													items-center
													justify-between
													gap-2
												"
											>
												<div
													class="break-all"
													v-html="
														g?.assessment_report
															?.note
													"
												></div>
												<img
													@click.stop="
														addNoteForGoal(g)
													"
													src="@/assets/images/icons/edit-fill.png"
													alt=""
												/>
											</div>
											<div
												v-else
												class="luca-ai w-max"
												@click.stop="addNoteForGoal(g)"
											>
												Thêm nhận xét
											</div>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
				<div v-if="step === 2 || !editReport">
					<div v-if="editReport" class="relative mt-12">
						<div
							aria-hidden="true"
							class="absolute inset-0 flex items-center"
						>
							<div class="w-full border-t border-neutral-300" />
						</div>
						<div class="relative flex items-center justify-between">
							<span
								class="
									pr-3
									bg-body
									text-lg
									font-semibold
									text-neutral-600
									mb-2
								"
							>
								Bước 2: Nhận xét chung
							</span>
							<button
								v-if="report?.state === 'completed'"
								:disabled="!noteContent"
								class="
									button-p
									text-center
									whitespace-nowrap
									w-fit
									md-down:hidden
								"
								type="button"
								@click="submit(report, true)"
							>
								<svg
									class="mr-2"
									fill="none"
									height="10"
									viewBox="0 0 6 10"
									width="6"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M1 9L5 5L1 1"
										stroke="currentColor"
										stroke-linecap="round"
										stroke-linejoin="round"
										stroke-width="2"
									/>
								</svg>
								Cập nhật báo cáo
							</button>
							<button
								v-else
								:disabled="!noteContent"
								class="
									button-p
									text-center
									whitespace-nowrap
									w-fit
									md-down:hidden
								"
								type="button"
								@click="step = 3"
							>
								<svg
									class="mr-2"
									fill="none"
									height="10"
									viewBox="0 0 6 10"
									width="6"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M1 9L5 5L1 1"
										stroke="currentColor"
										stroke-linecap="round"
										stroke-linejoin="round"
										stroke-width="2"
									/>
								</svg>
								Bước 3: Kế hoạch tiếp theo
							</button>
						</div>
					</div>
					<div v-if="alertShow && editReport" class="mt-12">
						<div
							class="
								bg-yellow-50
								border-l-4 border-yellow-600
								p-4
								rounded-md
							"
						>
							<div class="relative">
								<div class="flex items-center gap-4">
									<div>
										<img
											alt="luca-logo"
											height="24"
											src="@/assets/images/logo/logo.svg"
											width="35"
										/>
									</div>
									<div class="pt-1 text-neutral-600 text-sm">
										Bạn hãy hoàn thành
										<b
											>Nhận xét chung/ lưu ý cho phụ
											huynh</b
										>
										để nộp báo cáo
									</div>
								</div>
								<div
									class="
										top-1
										right-2
										absolute
										cursor-pointer
									"
									@click="alertShow = false"
								>
									<svg
										fill="none"
										height="12"
										viewBox="0 0 12 12"
										width="12"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											clip-rule="evenodd"
											d="M0.292893 0.292893C0.683417 -0.0976311 1.31658 -0.0976311 1.70711 0.292893L6 4.58579L10.2929 0.292893C10.6834 -0.0976311 11.3166 -0.0976311 11.7071 0.292893C12.0976 0.683417 12.0976 1.31658 11.7071 1.70711L7.41421 6L11.7071 10.2929C12.0976 10.6834 12.0976 11.3166 11.7071 11.7071C11.3166 12.0976 10.6834 12.0976 10.2929 11.7071L6 7.41421L1.70711 11.7071C1.31658 12.0976 0.683417 12.0976 0.292893 11.7071C-0.0976311 11.3166 -0.0976311 10.6834 0.292893 10.2929L4.58579 6L0.292893 1.70711C-0.0976311 1.31658 -0.0976311 0.683417 0.292893 0.292893Z"
											fill="#E5A42B"
											fill-rule="evenodd"
										/>
									</svg>
								</div>
							</div>
						</div>
					</div>
					<div v-if="editReport" class="py-10">
						<div
							class="
								bg-white
								shadow-sm
								rounded-2xl
								overflow-hidden
								p-6
							"
						>
							<div class="flex items-center justify-between mb-4">
								<div>
									<div class="font-semibold text-neutral-700">
										Nhận xét chung/ lưu ý cho phụ huynh
									</div>
								</div>
								<svg
									@click="sideOverShow = true"
									class="cursor-pointer"
									width="24"
									height="24"
									viewBox="0 0 24 24"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										fill-rule="evenodd"
										clip-rule="evenodd"
										d="M13.6308 5.68775L15.8838 3.43471C16.7496 2.56893 17.1825 2.13604 17.6895 1.99526C18.0396 1.89806 18.4095 1.89806 18.7596 1.99526C19.2667 2.13604 19.6996 2.56893 20.5653 3.43471C21.4311 4.3005 21.864 4.73339 22.0048 5.24044C22.102 5.59052 22.102 5.96046 22.0048 6.31054C21.864 6.8176 21.4311 7.25049 20.5653 8.11627L18.3384 10.3432C16.3859 9.2234 14.7651 7.61489 13.6308 5.68775ZM12.1764 7.14212L3.8659 15.4526C3.44084 15.8777 3.22831 16.0902 3.08857 16.3513C2.94884 16.6124 2.88989 16.9071 2.772 17.4966L1.98622 21.4255C1.91969 21.7581 1.88643 21.9244 1.98104 22.019C2.07564 22.1136 2.24194 22.0804 2.57452 22.0139L2.57455 22.0139L2.57456 22.0138L6.50349 21.2281L6.50351 21.2281C7.09295 21.1102 7.38767 21.0512 7.64876 20.9115C7.90986 20.7718 8.12239 20.5592 8.54743 20.1342L8.54745 20.1342L16.8803 11.8013C14.9786 10.6172 13.3722 9.02191 12.1764 7.14212Z"
										fill="#E5A42B"
									/>
								</svg>
							</div>
							<div>
								<div
									class="text-neutral-700"
									v-if="noteContent"
									v-html="
										noteContent.replace(/\n/g, '<br />')
									"
								></div>
								<div class="text-neutral-400" v-else>
									Nhận xét chung/ lưu ý cho phụ huynh
								</div>
							</div>
						</div>
					</div>
					<div v-if="editReport">
						<div class="relative">
							<div
								aria-hidden="true"
								class="absolute inset-0 flex items-center"
							>
								<div
									class="w-full border-t border-neutral-300"
								/>
							</div>
							<div class="relative flex justify-center">
								<div
									class="
										px-2.5
										py-1
										bg-body
										text-neutral-600
										font-semibold
										pb-2.5
									"
								>
									Nội dung báo cáo
								</div>
							</div>
						</div>
					</div>
					<div v-if="!editReport && !is_old_data">
						<div
							v-if="listVideo.length > 0"
							class="tabs flex my-10 gap-4"
						>
							<div v-for="tab in tabs" :key="tab.value">
								<div
									:class="{
										'tab-selected':
											tabSelected == tab.value,
									}"
									class="
										tab
										flex
										items-center
										justify-center
										cursor-pointer
									"
									@click="tabSelected = tab.value"
								>
									{{ tab.name }}
								</div>
							</div>
						</div>
						<div v-if="tabSelected == 0">
							<div class="relative mt-10">
								<div
									aria-hidden="true"
									class="absolute inset-0 flex items-center"
								>
									<div
										class="
											w-full
											border-t border-neutral-300
										"
									/>
								</div>
								<div class="relative flex justify-center">
									<div
										class="
											px-3
											bg-white
											p-2
											text-lg
											font-semibold
											text-neutral-600
											flex
											items-center
											shadow-sm
											rounded
											cursor-pointer
											border-neutral-200 border
										"
										@click="edit"
									>
										<svg
											fill="none"
											height="16"
											viewBox="0 0 17 16"
											width="17"
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												clip-rule="evenodd"
												d="M12.9705 6.65078L14.2105 5.41075C14.3463 5.27489 14.4143 5.20696 14.4669 5.14499C15.1011 4.39832 15.1011 3.30214 14.4669 2.55546C14.4143 2.4935 14.3463 2.42557 14.2105 2.28971C14.0746 2.15385 14.0067 2.08592 13.9447 2.03329C13.1981 1.39906 12.1019 1.39906 11.3552 2.03329C11.2933 2.08591 11.2253 2.15382 11.0895 2.28961L11.0895 2.28968L11.0894 2.28971L9.83123 3.54792C10.5749 4.84212 11.6586 5.91739 12.9705 6.65078ZM8.37657 5.00258L3.36297 10.0162C2.93791 10.4412 2.72538 10.6538 2.58565 10.9149C2.44591 11.176 2.38697 11.4707 2.26908 12.0601L1.87342 14.0384C1.8069 14.371 1.77364 14.5373 1.86825 14.6319C1.96286 14.7266 2.12916 14.6933 2.46177 14.6268L4.44005 14.2311L4.44007 14.2311L4.44009 14.2311C5.02951 14.1132 5.32423 14.0543 5.58532 13.9145C5.84641 13.7748 6.05894 13.5623 6.48398 13.1373L6.484 13.1372L6.48401 13.1372L11.512 8.10922C10.2513 7.311 9.18226 6.24913 8.37657 5.00258Z"
												fill="#94A3B8"
												fill-rule="evenodd"
											/>
										</svg>
										<div
											class="
												ml-2
												text-sm text-neutral-600
											"
										>
											Chỉnh sửa
										</div>
									</div>
									<div
										v-if="
											isAdmin &&
											report?.state === 'completed'
										"
										class="
											px-3
											bg-white
											p-2
											text-lg
											font-semibold
											text-neutral-600
											flex
											items-center
											shadow-sm
											rounded
											cursor-pointer
											border-neutral-200 border
											ml-1
										"
										@click="
											exportCSV(
												report?.student?.id,
												report?.id
											)
										"
									>
										<svg
											fill="none"
											height="16"
											viewBox="0 0 17 16"
											width="17"
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												clip-rule="evenodd"
												d="M8.5 0C7.07359 0 5.81176 0.560456 4.90576 1.34182C4.13985 2.00237 3.58479 2.8617 3.44223 3.725C1.76586 4.09512 0.5 5.55511 0.5 7.31818C0.5 9.36599 2.20754 11 4.28125 11H8V5.5C8 5.22386 8.22386 5 8.5 5C8.77614 5 9 5.22386 9 5.5V11H13.1875C15.0023 11 16.5 9.56949 16.5 7.77273C16.5 6.13656 15.2581 4.80411 13.6657 4.57898C13.4233 1.99944 11.1902 0 8.5 0Z"
												fill="#94A3B8"
												fill-rule="evenodd"
											/>
											<path
												clip-rule="evenodd"
												d="M8.14645 15.8536C8.34171 16.0488 8.65829 16.0488 8.85355 15.8536L11.8536 12.8536C12.0488 12.6583 12.0488 12.3417 11.8536 12.1464C11.6583 11.9512 11.3417 11.9512 11.1464 12.1464L9 14.2929V11H8V14.2929L5.85355 12.1464C5.65829 11.9512 5.34171 11.9512 5.14645 12.1464C4.95118 12.3417 4.95118 12.6583 5.14645 12.8536L8.14645 15.8536Z"
												fill="#94A3B8"
												fill-rule="evenodd"
											/>
										</svg>
										<div
											class="
												ml-2
												text-sm text-neutral-600
											"
										>
											Tải file .CSV
										</div>
									</div>
									<div
										v-if="
											isAdmin &&
											report?.state === 'completed'
										"
										class="
											px-3
											bg-white
											p-2
											text-lg
											font-semibold
											text-neutral-600
											flex
											items-center
											shadow-sm
											rounded
											cursor-pointer
											border-neutral-200 border
											ml-1
										"
										@click="downloadPDF"
									>
										<svg
											fill="none"
											height="16"
											viewBox="0 0 17 16"
											width="17"
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												clip-rule="evenodd"
												d="M8.5 0C7.07359 0 5.81176 0.560456 4.90576 1.34182C4.13985 2.00237 3.58479 2.8617 3.44223 3.725C1.76586 4.09512 0.5 5.55511 0.5 7.31818C0.5 9.36599 2.20754 11 4.28125 11H8V5.5C8 5.22386 8.22386 5 8.5 5C8.77614 5 9 5.22386 9 5.5V11H13.1875C15.0023 11 16.5 9.56949 16.5 7.77273C16.5 6.13656 15.2581 4.80411 13.6657 4.57898C13.4233 1.99944 11.1902 0 8.5 0Z"
												fill="#94A3B8"
												fill-rule="evenodd"
											/>
											<path
												clip-rule="evenodd"
												d="M8.14645 15.8536C8.34171 16.0488 8.65829 16.0488 8.85355 15.8536L11.8536 12.8536C12.0488 12.6583 12.0488 12.3417 11.8536 12.1464C11.6583 11.9512 11.3417 11.9512 11.1464 12.1464L9 14.2929V11H8V14.2929L5.85355 12.1464C5.65829 11.9512 5.34171 11.9512 5.14645 12.1464C4.95118 12.3417 4.95118 12.6583 5.14645 12.8536L8.14645 15.8536Z"
												fill="#94A3B8"
												fill-rule="evenodd"
											/>
										</svg>
										<div
											class="
												ml-2
												text-sm text-neutral-600
											"
										>
											Tải file .PDF
										</div>
									</div>
								</div>
							</div>
						</div>
						<div
							v-if="tabSelected == 1"
							class="flex flex-wrap gap-4"
						>
							<div v-for="i in listVideo" :key="i.id">
								<video controls width="215">
									<source
										:src="i.asset_url"
										type="video/mp4"
									/>
								</video>
							</div>
						</div>
					</div>
					<div v-if="!editReport && tabSelected == 0" class="mt-10">
						<div
							class="
								bg-white
								shadow-sm
								rounded-2xl
								overflow-hidden
								pb-4
							"
						>
							<div
								class="
									bg-orange-50
									p-4
									px-6
									flex
									md:items-center
									justify-between
									text-gray-700
									md-down:flex-col
								"
							>
								<div class="font-semibold text-lg">
									Báo cáo
									<span class="text-green-500"
										>Kế Hoạch
										{{
											report?.report_for_plan?.order
										}}</span
									>
								</div>
								<div
									v-if="report?.read_by_parent"
									class="flex items-center md-down:mt-1"
								>
									<span v-if="report?.read_by_parent_role">{{
										report?.read_by_parent_role
									}}</span
									><span v-else>Phụ huynh</span>
									<span class="ml-1.5"> xác nhận đã xem</span>
									<div class="ml-2">
										<svg
											fill="none"
											height="20"
											viewBox="0 0 20 20"
											width="20"
											xmlns="http://www.w3.org/2000/svg"
										>
											<mask
												id="path-1-inside-1_6533_14812"
												fill="white"
											>
												<path
													d="M9.26842 5.21202H2.62983C1.64107 5.21202 0.833984 6.01907 0.833984 7.00787V14.7764C0.833984 15.7652 1.64104 16.5723 2.62983 16.5723H5.05117L5.05131 19.2962C5.05131 19.9016 5.75761 20.2245 6.20153 19.8208L10.0354 16.552H13.3244C14.3132 16.552 15.1203 15.745 15.1203 14.7562L15.1201 11.0838C11.8917 11.0838 9.2685 8.44048 9.2685 5.21195L9.26842 5.21202Z"
												/>
												<path
													d="M15.1402 0.833374C12.7189 0.833374 10.7616 2.79065 10.7616 5.21202C10.7616 7.63339 12.7189 9.59066 15.1402 9.59066C17.5616 9.59066 19.5189 7.63339 19.5189 5.21202C19.5189 2.79065 17.5616 0.833374 15.1402 0.833374ZM17.2791 4.60668L15.0999 6.78591C14.9788 6.90696 14.7972 6.98775 14.6155 6.98775C14.434 6.98775 14.2524 6.9071 14.1312 6.78591L12.981 5.63569C12.7187 5.37333 12.7187 4.92938 12.981 4.66717C13.2434 4.40482 13.6873 4.40482 13.9495 4.66717L14.5953 5.31294L16.2902 3.61802C16.5526 3.35566 16.9965 3.35566 17.2587 3.61802C17.5616 3.90051 17.5616 4.34443 17.2791 4.60668H17.2791Z"
												/>
											</mask>
											<path
												d="M9.26842 5.21202H2.62983C1.64107 5.21202 0.833984 6.01907 0.833984 7.00787V14.7764C0.833984 15.7652 1.64104 16.5723 2.62983 16.5723H5.05117L5.05131 19.2962C5.05131 19.9016 5.75761 20.2245 6.20153 19.8208L10.0354 16.552H13.3244C14.3132 16.552 15.1203 15.745 15.1203 14.7562L15.1201 11.0838C11.8917 11.0838 9.2685 8.44048 9.2685 5.21195L9.26842 5.21202Z"
												fill="#339588"
											/>
											<path
												d="M15.1402 0.833374C12.7189 0.833374 10.7616 2.79065 10.7616 5.21202C10.7616 7.63339 12.7189 9.59066 15.1402 9.59066C17.5616 9.59066 19.5189 7.63339 19.5189 5.21202C19.5189 2.79065 17.5616 0.833374 15.1402 0.833374ZM17.2791 4.60668L15.0999 6.78591C14.9788 6.90696 14.7972 6.98775 14.6155 6.98775C14.434 6.98775 14.2524 6.9071 14.1312 6.78591L12.981 5.63569C12.7187 5.37333 12.7187 4.92938 12.981 4.66717C13.2434 4.40482 13.6873 4.40482 13.9495 4.66717L14.5953 5.31294L16.2902 3.61802C16.5526 3.35566 16.9965 3.35566 17.2587 3.61802C17.5616 3.90051 17.5616 4.34443 17.2791 4.60668H17.2791Z"
												fill="#339588"
											/>
											<path
												d="M9.26842 5.21202V6.21202H9.68041L9.97284 5.92181L9.26842 5.21202ZM5.05117 16.5723L6.05117 16.5722L6.05112 15.5723H5.05117V16.5723ZM5.05131 19.2962H6.05131V19.2962L5.05131 19.2962ZM6.20153 19.8208L5.55273 19.0599L5.54057 19.0702L5.52876 19.081L6.20153 19.8208ZM10.0354 16.552V15.552H9.66693L9.38656 15.7911L10.0354 16.552ZM15.1203 14.7562H16.1203V14.7561L15.1203 14.7562ZM15.1201 11.0838L16.1201 11.0837L16.1201 10.0838H15.1201V11.0838ZM9.2685 5.21195H10.2685V2.81066L8.56408 4.50216L9.2685 5.21195ZM17.2791 4.60668V3.60668H16.8649L16.572 3.89957L17.2791 4.60668ZM15.0999 6.78591L14.3927 6.0788V6.0788L15.0999 6.78591ZM14.1312 6.78591L14.8384 6.07883L14.8383 6.0788L14.1312 6.78591ZM12.981 4.66717L13.6879 5.37449L13.6881 5.37428L12.981 4.66717ZM13.9495 4.66717L13.2422 5.37408L13.2424 5.37428L13.9495 4.66717ZM14.5953 5.31294L13.8882 6.02005L14.5953 6.72716L15.3024 6.02005L14.5953 5.31294ZM17.2587 3.61802L16.5514 4.32492L16.5638 4.33735L16.5767 4.34934L17.2587 3.61802ZM17.2791 4.60668V5.60668H17.6718L17.9595 5.33955L17.2791 4.60668ZM9.26842 4.21202H2.62983V6.21202H9.26842V4.21202ZM2.62983 4.21202C1.0888 4.21202 -0.166016 5.46677 -0.166016 7.00787H1.83398C1.83398 6.57137 2.19334 6.21202 2.62983 6.21202V4.21202ZM-0.166016 7.00787V14.7764H1.83398V7.00787H-0.166016ZM-0.166016 14.7764C-0.166016 16.3175 1.08874 17.5723 2.62983 17.5723V15.5723C2.19333 15.5723 1.83398 15.2129 1.83398 14.7764H-0.166016ZM2.62983 17.5723H5.05117V15.5723H2.62983V17.5723ZM4.05117 16.5723L4.05131 19.2963L6.05131 19.2962L6.05117 16.5722L4.05117 16.5723ZM4.05131 19.2962C4.05131 20.7308 5.75932 21.5746 6.8743 20.5607L5.52876 19.081C5.56957 19.0439 5.63148 19.0125 5.70324 19.003C5.7699 18.9941 5.82886 19.0061 5.87522 19.0272C5.97096 19.0709 6.05131 19.1771 6.05131 19.2962H4.05131ZM6.85034 20.5818L10.6842 17.313L9.38656 15.7911L5.55273 19.0599L6.85034 20.5818ZM10.0354 17.552H13.3244V15.552H10.0354V17.552ZM13.3244 17.552C14.8655 17.552 16.1203 16.2973 16.1203 14.7562H14.1203C14.1203 15.1927 13.7609 15.552 13.3244 15.552V17.552ZM16.1203 14.7561L16.1201 11.0837L14.1201 11.0838L14.1203 14.7562L16.1203 14.7561ZM15.1201 10.0838C12.4485 10.0838 10.2685 7.89266 10.2685 5.21195H8.2685C8.2685 8.98829 11.335 12.0838 15.1201 12.0838V10.0838ZM8.56408 4.50216L8.56401 4.50223L9.97284 5.92181L9.97291 5.92174L8.56408 4.50216ZM15.1402 -0.166626C12.1666 -0.166626 9.7616 2.23836 9.7616 5.21202H11.7616C11.7616 3.34294 13.2712 1.83337 15.1402 1.83337V-0.166626ZM9.7616 5.21202C9.7616 8.18567 12.1666 10.5907 15.1402 10.5907V8.59066C13.2712 8.59066 11.7616 7.0811 11.7616 5.21202H9.7616ZM15.1402 10.5907C18.1139 10.5907 20.5189 8.18567 20.5189 5.21202H18.5189C18.5189 7.0811 17.0093 8.59066 15.1402 8.59066V10.5907ZM20.5189 5.21202C20.5189 2.23836 18.1139 -0.166626 15.1402 -0.166626V1.83337C17.0093 1.83337 18.5189 3.34293 18.5189 5.21202H20.5189ZM16.572 3.89957L14.3927 6.0788L15.807 7.49302L17.9862 5.31378L16.572 3.89957ZM14.3927 6.0788C14.428 6.04356 14.4614 6.02372 14.4897 6.01171C14.5185 5.9995 14.5601 5.98775 14.6155 5.98775V7.98775C15.0749 7.98775 15.5074 7.79262 15.807 7.49302L14.3927 6.0788ZM14.6155 5.98775C14.6709 5.98775 14.7125 5.99947 14.7413 6.01169C14.7696 6.02372 14.8031 6.0436 14.8384 6.07883L13.4241 7.49298C13.724 7.79296 14.1566 7.98775 14.6155 7.98775V5.98775ZM14.8383 6.0788L13.6881 4.92858L12.2739 6.34279L13.4241 7.49302L14.8383 6.0788ZM13.6881 4.92858C13.7593 4.99977 13.7842 5.08446 13.7842 5.15137C13.7842 5.21829 13.7593 5.30314 13.6879 5.37449L12.2741 3.95986C11.6208 4.61275 11.6211 5.69002 12.2739 6.34279L13.6881 4.92858ZM13.6881 5.37428C13.6169 5.44547 13.5322 5.47041 13.4653 5.47041C13.3984 5.47041 13.3136 5.44546 13.2422 5.37408L14.6568 3.96027C14.0039 3.307 12.9267 3.3073 12.2739 3.96007L13.6881 5.37428ZM13.2424 5.37428L13.8882 6.02005L15.3024 4.60584L14.6566 3.96007L13.2424 5.37428ZM15.3024 6.02005L16.9973 4.32513L15.5831 2.91091L13.8882 4.60584L15.3024 6.02005ZM16.9973 4.32513C16.9261 4.39632 16.8414 4.42125 16.7745 4.42125C16.7076 4.42125 16.6228 4.39631 16.5514 4.32492L17.966 2.91112C17.3131 2.25785 16.2359 2.25814 15.5831 2.91091L16.9973 4.32513ZM16.5767 4.34934C16.5321 4.3078 16.4899 4.23178 16.4886 4.13418C16.4872 4.03723 16.5275 3.93999 16.5988 3.8738L17.9595 5.33955C18.6894 4.66193 18.6461 3.5445 17.9408 2.88671L16.5767 4.34934ZM17.2791 3.60668H17.2791V5.60668H17.2791V3.60668Z"
												fill="#339588"
												mask="url(#path-1-inside-1_6533_14812)"
											/>
										</svg>
									</div>
								</div>
							</div>
							<div
								class="
									flex
									items-start
									justify-between
									flex-nowrap
									md-down:flex-col md-down:items-start
									px-6
									mt-4
								"
							>
								<div>
									<div v-if="report?.apply_date">
										Ngày áp dụng KH:
										{{
											$filters.formatDate2(
												report?.apply_date
											)
										}}
									</div>
								</div>
							</div>
							<div
								class="
									flex
									items-start
									justify-between
									flex-nowrap
									md-down:flex-col md-down:items-start
									px-6
									mt-2.5
								"
							>
								<div>
									<div v-if="report?.done_date">
										Ngày kết thúc KH:
										{{
											$filters.formatDate2(
												report?.done_date
											)
										}}
										<span
											v-if="report?.is_pending_done_date"
											>(dự kiến)</span
										>
									</div>
								</div>
								<router-link
									:to="`/record/employee/${report?.submitted_by_staff?.id}`"
								>
									<div v-if="report?.submitted_by_staff">
										Trị liệu viên báo cáo
										<span
											class="font-semibold text-blue-700"
											>{{
												report?.submitted_by_staff?.name
											}}</span
										>
									</div>
								</router-link>
							</div>
							<div
								class="
									flex
									items-start
									justify-between
									flex-nowrap
									md-down:flex-col md-down:items-start
									px-6
									mt-2.5
								"
							>
								<div>
									<div v-if="report?.completed_at">
										Ngày hoàn thành BC:
										{{
											$filters.formatDate2(
												report?.completed_at
											)
										}}
									</div>
								</div>
								<div
									v-if="report && report.sent_at"
									class="flex items-center gap-2"
								>
									<router-link
										:to="`/record/employee/${report?.sent_by_staff?.id}`"
									>
										<div v-if="report?.sent_by_staff">
											<span
												class="
													font-semibold
													text-blue-700
												"
												>{{
													report?.sent_by_staff?.name
												}}</span
											>
										</div>
									</router-link>
									<span
										>đã gửi KH tới PH
										{{
											$filters.formatDateTime(
												report.sent_at
											)
										}}</span
									>
								</div>
							</div>
						</div>
					</div>
					<div
						v-if="report?.note && !editReport && tabSelected == 0"
						class="mt-10"
					>
						<div class="bg-white shadow-sm rounded-2xl">
							<div class="font-semibold text-neutral-600 p-6">
								Nhận xét chung của tháng
							</div>
							<div
								class="
									p-6
									border-t border-orange-100
									whitespace-pre-line
								"
								v-html="report?.note"
							></div>
						</div>
					</div>
					<div
						v-if="tabSelected == 0"
						class="
							bg-white
							shadow-sm
							rounded-2xl
							overflow-hidden
							mt-10
						"
					>
						<div class="font-semibold text-neutral-500 p-6">
							Chuyên cần
						</div>
						<div
							class="
								border-t border-orange-50
								p-6
								flex
								items-center
								justify-center
								flex-col
							"
						>
							<div
								class="text-neutral-600 font-semibold mb-5"
								style="font-size: 72px"
							>
								{{ report?.lesson_count }}
							</div>
							<div class="text-neutral-500 mb-2 text-center">
								Số buổi học tháng này
							</div>
							<div
								v-if="!enableSessionCount"
								class="text-neutral-400 italic font-light"
							>
								(PH không xem được thông tin này)
							</div>
							<div
								v-if="
									attendance.attendance_percent >= 0 && false
								"
								class="text-neutral-500 mb-5"
							>
								Tỷ lệ chuyên cần của trẻ tháng này so với tháng
								trước
							</div>
							<div v-if="false" class="flex items-center">
								<div
									v-if="attendance.attendance_percent > 0"
									class="
										text-neutral-600 text-4xl
										font-semibold
										mr-3
									"
								>
									{{
										Math.abs(
											Math.round(
												+attendance.attendance_percent *
													10
											) / 10
										) + '%'
									}}
								</div>
								<div
									v-show="
										+attendance?.attendance_compare_with_last_percent !==
										0
									"
									:class="
										+attendance?.attendance_compare_with_last_percent >=
										0
											? 'bg-green-50 text-green-400'
											: 'bg-sienna-50 text-sienna-400'
									"
									class="
										grow-value
										flex flex-nowrap
										rounded-lg
										py-1
										px-2
										items-center
										w-fit
									"
								>
									<svg
										:class="{
											'transform rotate-180':
												+attendance?.attendance_compare_with_last_percent >=
												0,
										}"
										fill="none"
										height="12"
										viewBox="0 0 10 12"
										width="10"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											clip-rule="evenodd"
											d="M4.36354 0.498901V9.45415L1.4547 6.54531L0.5 7.50001L5 12L9.5 7.50001L8.5453 6.54531L5.63646 9.45415V0.498901H4.36354Z"
											fill="currentColor"
											fill-rule="evenodd"
										/>
									</svg>
									<div
										class="
											ml-2
											font-bold
											text-sm text-neutral-700
										"
									>
										{{
											Math.abs(
												Math.round(
													+attendance?.attendance_compare_with_last_percent *
														10
												) / 10
											)
										}}%
									</div>
								</div>
							</div>
						</div>
					</div>
					<div
						v-if="
							radarData.length &&
							radarData[0]?.data.length >= 3 &&
							tabSelected == 0
						"
						class="mt-10"
					>
						<div
							class="
								bg-white
								shadow-sm
								overflow-hidden
								rounded-2xl
								mb-10
								pb-5
							"
						>
							<div class="font-semibold text-neutral-500 p-6">
								Biểu đồ mối tương quan giữa kết quả các lĩnh vực
								trong tháng
							</div>
							<div
								class="
									p-6
									border-t border-orange-50
									md-down:px-0
									overflow-x-auto
									w-full
								"
							>
								<apexchart
									:options="radarChartOptions"
									:series="radarData"
									height="700"
									type="radar"
								>
								</apexchart>
								<div
									class="
										py-4
										flex flex-wrap
										gap-6
										justify-center
										items-center
									"
								>
									<div
										v-for="(c, index) in categories"
										:key="c"
										class="
											flex
											items-center
											flex-nowrap
											gap-2
										"
									>
										<div
											class="
												font-bold
												text-lf text-neutral-700
											"
										>
											{{ index + 1 }}: {{ c }}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div v-if="tabSelected == 0" class="mt-10">
						<div
							class="
								bg-white
								shadow-sm
								rounded-2xl
								overflow-hidden
								mb-10
								pb-5
							"
						>
							<div class="font-semibold text-neutral-500 p-6">
								Mối tương quan giữa kết quả, cảm xúc và sự tham
								gia của trẻ trong tháng
							</div>
							<div
								class="
									p-6
									border-t border-orange-50
									md-down:px-0
									overflow-x-auto
									w-full
								"
							>
								<apexchart
									ref="mixChart"
									:options="mixChartOptions"
									:series="
										emotion_cooperation_result_by_day_data
									"
									height="600"
									style="min-width: 1000px; width: 100%"
									width="100%"
								></apexchart>
							</div>
						</div>
					</div>
					<div v-if="tabSelected == 0" class="relative mt-12">
						<div
							aria-hidden="true"
							class="absolute inset-0 flex items-center"
						>
							<div class="w-full border-t border-neutral-300" />
						</div>
						<div class="relative flex items-center justify-center">
							<div
								class="
									px-2.5
									py-1
									bg-body
									text-neutral-600
									font-semibold
								"
							>
								Kết quả can thiệp tại thời điểm báo cáo
							</div>
						</div>
					</div>
					<div v-if="tabSelected == 0" class="mt-10">
						<div class="p-6 bg-white shadow-sm rounded-2xl">
							<div class="font-semibold text-neutral-600 mb-6">
								Thống kê của tháng
								{{ $filters.toMMYYY(report?.month_start) }}
							</div>
							<div
								class="flex flex-nowrap w-full md-down:flex-col"
							>
								<div
									v-if="false"
									class="
										p-6
										border
										rounded-l-lg
										border-neutral-200
										w-full
										md-down:rounded-t md-down:rounded-b-none
									"
								>
									<div
										class="
											text-33
											font-bold
											text-neutral-600
											mb-6
											flex flex-nowrap
											items-center
										"
									>
										<img
											alt=""
											class="mr-2 mb-1"
											height="32"
											src="@/assets/images/icons/schedule.png"
											style="height: 32px"
											width="32"
										/>
										{{ report?.lesson_count }}
									</div>
									<div class="flex flex-nowrap items-center">
										<span class="text-neutral-500 text-sm"
											>Tống số buổi học
										</span>
									</div>
								</div>
								<div
									class="
										p-6
										border
										rounded-l-lg
										border-neutral-200
										w-full
										md-down:rounded-t md-down:rounded-b-none
									"
								>
									<div
										class="
											text-33
											font-bold
											text-neutral-600
											mb-6
											flex flex-nowrap
											items-center
										"
									>
										<img
											alt=""
											class="mr-2"
											height="32"
											src="@/assets/images/icons/abc.png"
											style="height: 32px"
											width="32"
										/>
										{{
											Number(report?.skill_count || 0) +
											'/' +
											Number(
												stats?.total_skill_count || 0
											)
										}}
									</div>
									<div class="flex flex-nowrap items-center">
										<span class="text-neutral-500 text-sm"
											>Lĩnh vực đã học
										</span>
									</div>
								</div>
								<div
									class="
										p-6
										border-t border-b border-neutral-200
										w-full
										md-down:border-l
										md-down:border-r
										md-down:border-b-0
									"
								>
									<div
										class="
											text-33
											font-bold
											text-neutral-600
											mb-6
											flex flex-nowrap
											items-center
										"
									>
										<img
											alt=""
											class="mr-2"
											height="32"
											src="@/assets/images/icons/light.png"
											style="height: 32px"
											width="32"
										/>
										{{
											Number(report?.goal_count || 0) +
											'/' +
											Number(stats?.total_goal_count || 0)
										}}
									</div>
									<div class="flex flex-nowrap items-center">
										<span class="text-neutral-500 text-sm"
											>Mục tiêu đã học
										</span>
									</div>
								</div>
								<div
									class="
										p-6
										border-l
										border-t
										border-b
										border-neutral-200
										w-full
										md-down:border-r md-down:border-b-0
									"
								>
									<div
										class="
											text-33
											font-bold
											text-neutral-600
											mb-6
											flex flex-nowrap
											items-center
										"
									>
										<img
											alt=""
											class="mr-2"
											height="32"
											src="@/assets/images/icons/light.png"
											style="height: 32px"
											width="32"
										/>
										{{
											assessment_report_next_plan
												?.completed?.count
										}}
									</div>
									<div class="flex flex-nowrap items-center">
										<span class="text-neutral-500 text-sm"
											>Mục tiêu đã hoàn thành
										</span>
									</div>
								</div>
								<div
									class="
										p-6
										border-l
										border-t
										border-b
										border-neutral-200
										w-full
										md-down:border-r md-down:border-b-0
									"
								>
									<div
										class="
											text-33
											font-bold
											text-neutral-600
											mb-6
											flex flex-nowrap
											items-center
										"
									>
										<img
											alt=""
											class="mr-2"
											height="32"
											src="@/assets/images/icons/light.png"
											style="height: 32px"
											width="32"
										/>
										{{
											assessment_report_next_plan
												?.continued?.count
										}}
									</div>
									<div class="flex flex-nowrap items-center">
										<span class="text-neutral-500 text-sm"
											>Mục tiêu sẽ tiếp tục
										</span>
									</div>
								</div>
								<div
									class="
										p-6
										border
										rounded-r-lg
										border-neutral-200
										w-full
										md-down:rounded-b md-down:rounded-t-none
									"
								>
									<div
										class="
											text-33
											font-bold
											text-neutral-600
											mb-6
											flex flex-nowrap
											items-center
										"
									>
										<img
											alt=""
											class="mr-2"
											height="32"
											src="@/assets/images/icons/light.png"
											style="height: 32px"
											width="32"
										/>
										{{
											assessment_report_next_plan?.stopped
												?.count
										}}
									</div>
									<div class="flex flex-nowrap items-center">
										<span class="text-neutral-500 text-sm"
											>Mục tiêu sẽ tạm dừng</span
										>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div v-if="tabSelected == 0" class="mt-10">
						<div class="grid grid-cols-2 gap-8 xl-down:grid-cols-1">
							<div
								class="
									bg-white
									shadow-sm
									rounded-2xl
									overflow-hidden
								"
							>
								<div class="font-semibold text-neutral-500 p-6">
									Cảm xúc của trẻ trong tháng
								</div>
								<div
									class="
										border-t border-orange-50
										flex
										justify-center
										items-center
										p-6
										md-down:flex-col
									"
								>
									<div
										class="
											relative
											w-1/2
											md-down:w-full
											flex
											items-center
											justify-center
										"
									>
										<apexchart
											:options="chartOptions3"
											:series="series3"
											height="220"
											type="donut"
										>
										</apexchart>
										<div
											class="
												text-center
												absolute
												top-1/2
												left-1/2
												transform
											"
											style="
												transform: translate(
													-50%,
													-50%
												);
											"
										>
											<div class="text-neutral-500">
												Cảm xúc
											</div>
										</div>
									</div>
									<div
										class="
											w-1/3
											md-down:w-full md-down:mt-4
										"
									>
										<div
											v-if="series3[0] > 0"
											class="
												flex flex-nowrap
												items-center
												justify-between
												w-full
											"
										>
											<div
												class="
													flex flex-nowrap
													items-center
												"
											>
												<img
													alt=""
													height="24"
													src="@/assets/images/emoji/happy.png"
													width="24"
												/>
												<div
													class="
														h-2.5
														w-2.5
														rounded-full
														ml-2
													"
													style="background: #9edf93"
												></div>
												<div
													class="
														ml-2
														text-base
														text-neutral-500
													"
												>
													Vui vẻ
												</div>
											</div>
											<div
												class="
													text-base text-neutral-600
													font-bold
												"
											>
												{{ series3[0] }}
												%
											</div>
										</div>
										<div
											v-if="series3[1] > 0"
											class="
												flex flex-nowrap
												items-center
												justify-between
												w-full
												mt-2.5
											"
										>
											<div
												class="
													flex flex-nowrap
													items-center
												"
											>
												<img
													alt=""
													height="24"
													src="@/assets/images/emoji/5565d66a50b44df9ae37a955bdfb3757.png"
													width="24"
												/>
												<div
													class="
														h-2.5
														w-2.5
														rounded-full
														ml-2
													"
													style="background: #d0db54"
												></div>
												<div
													class="
														ml-2
														text-base
														text-neutral-500
													"
												>
													Bình thường
												</div>
											</div>
											<div
												class="
													text-base text-neutral-600
													font-bold
												"
											>
												{{ series3[1] }}
												%
											</div>
										</div>
										<div
											v-if="series3[2] > 0"
											class="
												flex flex-nowrap
												items-center
												justify-between
												w-full
												mt-2.5
											"
										>
											<div
												class="
													flex flex-nowrap
													items-center
												"
											>
												<img
													alt=""
													height="24"
													src="@/assets/images/emoji/cf1f643bc1244f5e8e37767bc946d607.png"
													width="24"
												/>
												<div
													class="
														h-2.5
														w-2.5
														rounded-full
														ml-2
													"
													style="background: #ffe68c"
												></div>
												<div
													class="
														ml-2
														text-base
														text-neutral-500
													"
												>
													Khó chịu
												</div>
											</div>
											<div
												class="
													text-base text-neutral-600
													font-bold
												"
											>
												{{ series3[2] }}
												%
											</div>
										</div>
										<div
											v-if="series3[3] > 0"
											class="
												flex flex-nowrap
												items-center
												justify-between
												w-full
												mt-2.5
											"
										>
											<div
												class="
													flex flex-nowrap
													items-center
												"
											>
												<img
													alt=""
													height="24"
													src="@/assets/images/emoji/5ede936757cd4fbdb6247bad22bf454d.png"
													width="24"
												/>
												<div
													class="
														h-2.5
														w-2.5
														rounded-full
														ml-2
													"
													style="background: #ff9d6d"
												></div>
												<div
													class="
														ml-2
														text-base
														text-neutral-500
													"
												>
													Tức giận
												</div>
											</div>
											<div
												class="
													text-base text-neutral-600
													font-bold
												"
											>
												{{ series3[3] }}
												%
											</div>
										</div>
										<div
											v-if="series3[4] > 0"
											class="
												flex flex-nowrap
												items-center
												justify-between
												w-full
												mt-2.5
											"
										>
											<div
												class="
													flex flex-nowrap
													items-center
												"
											>
												<img
													alt=""
													height="24"
													src="@/assets/images/emoji/0b356bb507d64b9489e2fbced131f795.png"
													width="24"
												/>
												<div
													class="
														h-2.5
														w-2.5
														rounded-full
														ml-2
													"
													style="background: #ff6967"
												></div>
												<div
													class="
														ml-2
														text-base
														text-neutral-500
													"
												>
													Bùng nổ
												</div>
											</div>
											<div
												class="
													text-base text-neutral-600
													font-bold
												"
											>
												{{ series3[4] }}
												%
											</div>
										</div>
									</div>
								</div>
							</div>
							<div
								class="
									bg-white
									shadow-sm
									rounded-2xl
									overflow-hidden
								"
							>
								<div class="font-semibold text-neutral-500 p-6">
									Kết quả mục tiêu đã học
								</div>
								<div
									class="
										flex flex-nowrap
										p-6
										border-t border-orange-50
										items-center
										justify-center
										md-down:flex-col
									"
								>
									<div class="relative w-fit md-down:w-full">
										<apexchart
											:options="chartOptions"
											:series="series"
											height="220"
											type="donut"
										>
										</apexchart>
										<div
											class="
												text-center
												absolute
												top-1/2
												left-1/2
												transform
											"
											style="
												transform: translate(
													-50%,
													-50%
												);
											"
										>
											<div
												class="
													text-4xl
													font-bold
													text-neutral-600
												"
											>
												{{ report?.goal_count }}
											</div>
											<div class="text-neutral-500">
												Mục tiêu
											</div>
										</div>
									</div>
									<div
										class="
											flex flex-col
											justify-center
											md-down:mt-4
										"
									>
										<div
											v-if="
												assessment_result[0]?.count > 0
											"
											class="
												flex flex-nowrap
												items-center
												mb-4
											"
										>
											<div
												class="
													text-sm
													font-semibold
													text-neutral-500
													w-14
													blue
												"
											>
												{{
													assessment_result[0]?.count
												}}
												M.T
											</div>
											<span
												class="
													flex
													items-center
													justify-center
													py-0.5
													rounded-full
													text-sm text-white
													font-semibold
													whitespace-nowrap
													w-32
													shadow-input
												"
												style="background: #2aa797"
											>
												{{
													assessment_result[0]?.result
												}}
											</span>
										</div>
										<div
											v-if="
												assessment_result[1]?.count > 0
											"
											class="
												flex flex-nowrap
												items-center
												mb-4
											"
										>
											<div
												class="
													text-sm
													font-semibold
													text-neutral-500
													w-14
												"
											>
												{{
													assessment_result[1]?.count
												}}
												M.T
											</div>
											<span
												class="
													flex
													items-center
													justify-center
													py-0.5
													rounded-full
													text-sm text-white
													font-semibold
													w-32
													whitespace-nowrap
													shadow-input
												"
												style="background: #65a30d"
											>
												{{
													assessment_result[1]?.result
												}}
											</span>
										</div>
										<div
											v-if="
												assessment_result[2]?.count > 0
											"
											class="
												flex flex-nowrap
												items-center
												mb-4
											"
										>
											<div
												class="
													text-sm
													font-semibold
													text-neutral-500
													w-14
												"
											>
												{{
													assessment_result[2]?.count
												}}
												M.T
											</div>
											<span
												class="
													flex
													items-center
													justify-center
													py-0.5
													rounded-full
													text-sm text-white
													font-semibold
													w-32
													whitespace-nowrap
													shadow-input
												"
												style="background: #f59e0b"
											>
												{{
													assessment_result[2]?.result
												}}
											</span>
										</div>
										<div
											v-if="
												assessment_result[3]?.count > 0
											"
											class="
												flex flex-nowrap
												items-center
												mb-4
											"
										>
											<div
												class="
													text-sm
													font-semibold
													text-neutral-500
													w-14
													blue
												"
											>
												{{
													assessment_result[3]?.count
												}}
												M.T
											</div>
											<span
												class="
													flex
													items-center
													justify-center
													px-3
													py-0.5
													rounded-full
													text-sm text-white
													font-semibold
													w-32
													whitespace-nowrap
													shadow-input
												"
												style="background: #f87171"
											>
												{{
													assessment_result[3]?.result
												}}
											</span>
										</div>
										<div
											v-if="
												assessment_result[4]?.count >
													0 ||
												assessment_result[5]?.count >
													0 ||
												assessment_result[6]?.count > 0
											"
											class="
												flex flex-nowrap
												items-center
												mb-4
											"
										>
											<div
												class="
													text-sm
													font-semibold
													text-neutral-500
													w-14
													blue
												"
											>
												{{
													assessment_result[4]
														?.count +
													assessment_result[5]
														?.count +
													assessment_result[6]?.count
												}}
												M.T
											</div>
											<span
												class="
													flex
													items-center
													justify-center
													px-3
													py-0.5
													rounded-full
													text-sm text-white
													font-semibold
													w-32
													whitespace-nowrap
													shadow-input
												"
												style="background: #9ca3af"
											>
												X
											</span>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="mt-10">
							<div
								class="
									bg-white
									shadow-sm
									rounded-2xl
									overflow-hidden
								"
							>
								<div class="font-semibold text-neutral-500 p-6">
									So sánh với tháng trước
								</div>
								<div
									class="
										border-t border-orange-50
										grid grid-cols-3
										items-start
										md-down:grid-cols-1
									"
								>
									<div
										class="
											flex flex-col
											justify-center
											items-center
											py-6
										"
									>
										<apexchart
											:options="chartOptions2_1"
											:series="[
												Math.round(
													+report?.average_result_in_percent *
														10
												) / 10,
											]"
											height="240"
											type="radialBar"
										></apexchart>
										<div
											v-show="
												+compare_with_last.average_result !==
												0
											"
											:class="
												+compare_with_last.average_result >=
												0
													? 'bg-green-50 text-green-400'
													: 'bg-sienna-50 text-sienna-400'
											"
											class="
												grow-value
												flex flex-nowrap
												rounded-lg
												py-1
												px-2
												items-center
												w-fit
											"
										>
											<svg
												:class="{
													'transform rotate-180':
														+compare_with_last.average_result >=
														0,
												}"
												fill="none"
												height="12"
												viewBox="0 0 10 12"
												width="10"
												xmlns="http://www.w3.org/2000/svg"
											>
												<path
													clip-rule="evenodd"
													d="M4.36354 0.498901V9.45415L1.4547 6.54531L0.5 7.50001L5 12L9.5 7.50001L8.5453 6.54531L5.63646 9.45415V0.498901H4.36354Z"
													fill="currentColor"
													fill-rule="evenodd"
												/>
											</svg>
											<div
												class="
													ml-2
													font-bold
													text-sm text-neutral-700
												"
											>
												{{
													Math.abs(
														Math.round(
															+compare_with_last.average_result *
																10
														) / 10
													)
												}}%
											</div>
										</div>
									</div>
									<div
										class="
											flex flex-col
											justify-center
											items-center
											py-6
										"
									>
										<apexchart
											:options="chartOptions2_2"
											:series="[
												Math.round(
													((+report?.average_cooperation_scale *
														100) /
														5) *
														10
												) / 10,
											]"
											height="240"
											type="radialBar"
										></apexchart>
										<div
											v-show="
												+compare_with_last?.average_cooperation_scale !==
												0
											"
											:class="
												+compare_with_last?.average_cooperation_scale >=
												0
													? 'bg-green-50 text-green-400'
													: 'bg-sienna-50 text-sienna-400'
											"
											class="
												grow-value
												flex flex-nowrap
												rounded-lg
												py-1
												px-2
												items-center
												w-fit
											"
										>
											<svg
												:class="{
													'transform rotate-180':
														+compare_with_last?.average_cooperation_scale >=
														0,
												}"
												fill="none"
												height="12"
												viewBox="0 0 10 12"
												width="10"
												xmlns="http://www.w3.org/2000/svg"
											>
												<path
													clip-rule="evenodd"
													d="M4.36354 0.498901V9.45415L1.4547 6.54531L0.5 7.50001L5 12L9.5 7.50001L8.5453 6.54531L5.63646 9.45415V0.498901H4.36354Z"
													fill="currentColor"
													fill-rule="evenodd"
												/>
											</svg>
											<div
												class="
													ml-2
													font-bold
													text-sm text-neutral-700
												"
											>
												{{
													Math.abs(
														Math.round(
															+compare_with_last?.average_cooperation_scale *
																10
														) / 10
													)
												}}%
											</div>
										</div>
									</div>
									<div
										class="
											flex flex-col
											justify-center
											items-center
											py-6
										"
									>
										<apexchart
											:options="chartOptions2_3"
											:series="[
												Math.round(
													((+report?.average_emotion_scale *
														100) /
														5) *
														10
												) / 10,
											]"
											height="240"
											type="radialBar"
										></apexchart>
										<div
											v-show="
												+compare_with_last?.average_emotion_scale !==
												0
											"
											:class="
												+compare_with_last?.average_emotion_scale >=
												0
													? 'bg-green-50 text-green-400'
													: 'bg-sienna-50 text-sienna-400'
											"
											class="
												grow-value
												flex flex-nowrap
												rounded-lg
												py-1
												px-2
												items-center
												w-fit
											"
										>
											<svg
												:class="{
													'transform rotate-180':
														+compare_with_last?.average_emotion_scale >=
														0,
												}"
												fill="none"
												height="12"
												viewBox="0 0 10 12"
												width="10"
												xmlns="http://www.w3.org/2000/svg"
											>
												<path
													clip-rule="evenodd"
													d="M4.36354 0.498901V9.45415L1.4547 6.54531L0.5 7.50001L5 12L9.5 7.50001L8.5453 6.54531L5.63646 9.45415V0.498901H4.36354Z"
													fill="currentColor"
													fill-rule="evenodd"
												/>
											</svg>
											<div
												class="
													ml-2
													font-bold
													text-sm text-neutral-700
												"
											>
												{{
													Math.abs(
														Math.round(
															+compare_with_last?.average_emotion_scale *
																10
														) / 10
													)
												}}%
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div v-if="tabSelected == 0" class="mt-10">
						<div
							class="
								bg-white
								shadow-sm
								rounded-2xl
								overflow-hidden
								mb-10
								pb-5
							"
						>
							<div class="font-semibold text-neutral-500 p-6">
								Biểu đồ mối tương quan giữa kết quả các lĩnh vực
								so sánh với tháng trước
							</div>
							<div
								class="
									p-6
									border-t border-orange-50
									md-down:px-0
									overflow-x-auto
									w-full
								"
							>
								<apexchart
									ref="mixChart2"
									:options="mixChartOptions2"
									:series="
										emotion_cooperation_result_by_day_data2
									"
									height="600"
									style="min-width: 1000px; width: 100%"
									width="100%"
								/>
							</div>
						</div>
					</div>
					<div v-if="tabSelected == 0">
						<div
							v-for="(ass, index) in skillsShow"
							:key="index"
							class="mt-10"
						>
							<div
								class="
									font-semibold
									text-lg text-neutral-600
									mb-2
								"
							>
								{{ +index + 1 }}. {{ ass?.skill?.name }}
							</div>
							<div
								class="
									shadow-sm
									sm:rounded-2xl
									overflow-hidden
									md-down:hidden
								"
							>
								<div
									class="
										__record__table
										overflow-x-auto
										scroll-bar
									"
								>
									<div
										class="
											overflow-hidden
											sm:rounded-t-2xl
											w-fit
											min-w-full
										"
									>
										<table
											class="
												min-w-full
												divide-y
												text-neutral-200
											"
										>
											<thead class="bg-neutral-100 h-16">
												<tr>
													<th
														class="
															px-4
															py-3
															text-left text-xs
															font-semibold
															text-neutral-600
															uppercase
															tracking-wider
															whitespace-nowrap
															w-16
														"
														scope="col"
													>
														STT
													</th>
													<th
														class="
															px-6
															py-3
															text-left text-xs
															font-semibold
															text-neutral-600
															uppercase
															tracking-wider
															w-8/12
															whitespace-nowrap
														"
														scope="col"
														style="width: 406px"
													>
														Mục Tiêu
													</th>
													<th
														class="
															px-6
															py-3
															text-xs
															font-semibold
															text-neutral-600
															uppercase
															tracking-wider
															whitespace-nowrap
															text-left
														"
														scope="col"
														style="width: 145px"
													>
														Kết quả
													</th>
													<th
														class="
															px-6
															py-3
															text-left text-xs
															font-semibold
															text-neutral-600
															uppercase
															tracking-wider
															whitespace-nowrap
														"
														scope="col"
														style="width: 300px"
													>
														Nhận xét
													</th>
													<th
														class="
															px-6
															py-3
															text-left text-xs
															font-semibold
															text-neutral-600
															uppercase
															tracking-wider
															whitespace-nowrap
														"
														scope="col"
														style="width: 76px"
													>
														ALBUM
													</th>
													<th
														class="
															px-6
															py-3
															text-left text-xs
															font-semibold
															text-neutral-600
															uppercase
															tracking-wider
															whitespace-nowrap
														"
														scope="col"
														style="width: 120px"
													>
														Đánh giá
													</th>
												</tr>
											</thead>
											<tbody>
												<tr
													v-for="(
														assessment, index
													) in ass.goals"
													:key="assessment?.goal_id"
													:class="
														index % 2 === 0
															? 'bg-white'
															: 'bg-neutral-50'
													"
													class="
														cursor-pointer
														text-neutral-700
														hover:bg-orange-50
													"
													@click="
														$router.push(
															`/report/monthly-report/${report.student_id}/${assessment.goal_id}?month_start=${monthly_start}`
														)
													"
												>
													<td
														class="
															p-4
															whitespace-nowrap
															text-neutral-700
														"
													>
														<div class="ml-4">
															{{ index + 1 }}
														</div>
													</td>
													<td
														class="
															px-6
															py-4
															whitespace-nowrap
															text-neutral-700
														"
													>
														<div>
															<div
																class="
																	whitespace-normal
																"
																v-html="
																	assessment?.goal_name ||
																	assessment?.name
																"
															></div>
															<div
																class="
																	flex
																	gap-2
																	flex-wrap
																"
															>
																<div
																	v-if="
																		assessment?.raw_source
																	"
																	class="
																		mt-1
																		py-0.5
																		px-2.5
																		rounded-full
																		bg-neutral-200
																		text-neutral-700
																		h-fit
																		w-fit
																		whitespace-nowrap
																		font-semibold
																		shadow-input
																	"
																	style="
																		font-size: 10px;
																	"
																>
																	{{
																		assessment?.display_source
																	}}
																</div>
																<template
																	v-if="
																		assessment?.assistance_levels &&
																		org.enable_goal_assistance_level
																	"
																>
																	<div
																		v-for="ass in assessment?.assistance_levels"
																		:key="
																			ass
																		"
																	>
																		<div
																			class="
																				mt-1
																				py-0.5
																				px-2.5
																				rounded-full
																				bg-pink-100
																				whitespace-nowrap
																				text-neutral-700
																				h-fit
																				w-fit
																				font-semibold
																				shadow-input
																			"
																			style="
																				font-size: 10px;
																			"
																		>
																			{{
																				ass
																			}}
																		</div>
																	</div>
																</template>
																<div
																	class="
																		mt-1
																		py-0.5
																		px-2.5
																		rounded-full
																		bg-yellow-tag
																		text-neutral-700
																		h-fit
																		w-fit
																		font-semibold
																		shadow-input
																		whitespace-nowrap
																	"
																	style="
																		font-size: 10px;
																	"
																	v-if="
																		assessment?.age
																	"
																>
																	{{
																		assessment?.age
																	}}
																</div>
															</div>
															<div
																class="
																	flex
																	items-center
																	gap-2
																	mt-2
																"
															>
																<div
																	v-if="
																		assessment?.has_media
																	"
																>
																	<img
																		alt=""
																		src="@/assets/images/icons/has_media.png"
																	/>
																</div>
																<div
																	v-if="
																		assessment.number_of_assessment >
																		0
																	"
																	class="
																		text-neutral-400
																		text-xs
																		font-semibold
																	"
																>
																	ĐÃ HỌC
																	{{
																		assessment.number_of_assessment
																	}}
																	NGÀY
																</div>
																<div
																	v-if="
																		assessment?.completed_at
																	"
																>
																	<img
																		alt=""
																		src="@/assets/images/icons/has_taught.png"
																	/>
																</div>
															</div>
															<div
																v-if="
																	assessment
																		?.parent
																		?.sub_goal_count >
																	0
																"
																class="
																	p-3
																	py-2
																	rounded-xl
																	border
																	mt-2
																	flex
																	gap-3
																"
																style="
																	border: 1px
																		solid
																		#bacde4;
																	background: #eef3f8;
																"
															>
																<div
																	class="w-4"
																>
																	<svg
																		fill="none"
																		height="16"
																		viewBox="0 0 16 16"
																		width="16"
																		xmlns="http://www.w3.org/2000/svg"
																	>
																		<path
																			d="M2.66663 2.6665V8.6665C2.66663 9.37375 2.94758 10.052 3.44768 10.5521C3.94777 11.0522 4.62605 11.3332 5.33329 11.3332H11.3906L9.72396 12.9998L10.6666 13.9425L13.9426 10.6665L10.6666 7.3905L9.72396 8.33317L11.3906 9.99984H5.33329C4.97967 9.99984 4.64053 9.85936 4.39048 9.60931C4.14044 9.35926 3.99996 9.02013 3.99996 8.6665V2.6665H2.66663Z"
																			fill="#94A3B8"
																		/>
																	</svg>
																</div>
																<div>
																	<div
																		class="
																			whitespace-normal
																		"
																		v-html="
																			assessment
																				?.parent
																				?.name ??
																			assessment
																				?.parent
																				?.goal_name
																		"
																	></div>
																	<div
																		class="
																			text-sm
																			font-semibold
																		"
																		style="
																			color: #94a3b8;
																		"
																	>
																		{{
																			assessment
																				?.parent
																				?.sub_goal_count
																		}}
																		mục tiêu
																	</div>
																</div>
															</div>
														</div>
													</td>
													<td
														class="
															px-6
															py-4
															whitespace-nowrap
															text-neutral-700
														"
													>
														<div
															v-if="
																assessment
																	?.assessment_report
																	?.result
															"
															:style="{
																background:
																	$filters.tagResult(
																		assessment
																			?.assessment_report
																			?.complete_percent
																	)
																		?.background,
																color: $filters.tagResult(
																	assessment
																		?.assessment_report
																		?.complete_percent
																)?.color,
															}"
															class="
																py-0.5
																px-2.5
																rounded-full
																text-neutral-700
																h-fit
																w-fit
																font-semibold
																text-sm
																shadow-input
															"
														>
															{{
																assessment
																	?.assessment_report
																	?.result
															}}
														</div>
													</td>
													<td
														class="
															px-6
															py-4
															whitespace-nowrap
															text-neutral-700
														"
													>
														<div
															v-if="
																assessment
																	?.assessment_report
																	?.note
															"
															class="
																whitespace-normal
															"
														>
															{{
																assessment
																	?.assessment_report
																	?.note
															}}
														</div>
													</td>
													<td
														class="
															px-6
															py-4
															whitespace-nowrap
															text-neutral-700
														"
													>
														<div>
															<svg
																v-if="
																	assessment
																		?.assessment_report
																		?.has_goal_media
																"
																fill="none"
																height="20"
																viewBox="0 0 20 20"
																width="20"
																xmlns="http://www.w3.org/2000/svg"
															>
																<path
																	clip-rule="evenodd"
																	d="M15.002 5H2.50195C1.8116 5 1.25195 5.55964 1.25195 6.25V16.25L4.56001 13.3081C4.77068 13.0974 5.10075 13.0647 5.34864 13.23L8.67232 15.4458L13.31 10.8081C13.5002 10.6179 13.7908 10.5707 14.0315 10.691L16.252 13.125V6.25C16.252 5.55964 15.6923 5 15.002 5ZM2.50195 3.75C1.12124 3.75 0.00195312 4.86929 0.00195312 6.25V16.25C0.00195312 17.6307 1.12124 18.75 2.50195 18.75H15.002C16.3827 18.75 17.502 17.6307 17.502 16.25V6.25C17.502 4.86929 16.3827 3.75 15.002 3.75H2.50195ZM7.50195 9.375C7.50195 10.4105 6.66249 11.25 5.62695 11.25C4.59142 11.25 3.75195 10.4105 3.75195 9.375C3.75195 8.33947 4.59142 7.5 5.62695 7.5C6.66249 7.5 7.50195 8.33947 7.50195 9.375Z"
																	fill="#E5A42B"
																	fill-rule="evenodd"
																/>
																<path
																	clip-rule="evenodd"
																	d="M4.5 2.25H18C18.5523 2.25 19 2.69772 19 3.25V14.25C19 14.8023 18.5523 15.25 18 15.25H17.5V16.25H18C19.1046 16.25 20 15.3546 20 14.25V3.25C20 2.14543 19.1046 1.25 18 1.25H4.5C3.39543 1.25 2.5 2.14543 2.5 3.25V3.75H3.5V3.25C3.5 2.69772 3.94772 2.25 4.5 2.25Z"
																	fill="#E5A42B"
																	fill-rule="evenodd"
																/>
															</svg>
														</div>
													</td>
													<td
														class="
															px-6
															py-4
															whitespace-nowrap
															text-neutral-700
														"
													>
														<div
															class="
																whitespace-normal
																w-56
															"
														>
															<div
																class="
																	w-56
																	flex
																	items-center
																	gap-1
																"
																v-if="
																	assessment
																		?.assessment_report
																		?.next_plan ==
																	'Mục tiêu đã hoàn thành'
																"
															>
																<svg
																	width="16"
																	height="16"
																	viewBox="0 0 16 16"
																	fill="none"
																	xmlns="http://www.w3.org/2000/svg"
																>
																	<path
																		fill-rule="evenodd"
																		clip-rule="evenodd"
																		d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM12.0303 4.96967C11.7374 4.67678 11.2625 4.67678 10.9697 4.96967C10.9626 4.97674 10.9559 4.98424 10.9498 4.9921L7.47739 9.41674L5.38387 7.32322C5.09097 7.03033 4.6161 7.03033 4.32321 7.32322C4.03031 7.61612 4.03031 8.09099 4.32321 8.38388L6.96965 11.0303C7.26255 11.3232 7.73742 11.3232 8.03031 11.0303C8.03684 11.0238 8.04299 11.0169 8.04875 11.0097L12.041 6.01947C12.3232 5.72582 12.3196 5.25897 12.0303 4.96967Z"
																		fill="#2AA797"
																	/>
																</svg>

																<div>
																	Mục tiêu đã
																	hoàn thành
																</div>
															</div>
															<div
																class="
																	whitespace-normal
																	w-56
																"
																v-else
															>
																{{
																	reason(
																		assessment?.assessment_report
																	)
																}}
															</div>
														</div>
													</td>
												</tr>
											</tbody>
										</table>
									</div>
								</div>
							</div>
							<div>
								<div
									v-for="(assessment, index) in ass?.goals"
									:key="assessment.goal_id"
									class="
										shadow-sm
										rounded-lg
										overflow-hidden
										md:hidden
										mb-4
										bg-white
									"
									@click="
										$router.push(
											`/report/monthly-report/${report.student_id}/${assessment.goal_id}?month_start=${monthly_start}`
										)
									"
								>
									<div
										class="
											font-semibold
											text-neutral-600
											p-4
										"
									>
										<div>
											{{ index + 1 }}.
											{{
												assessment?.goal_name ||
												assessment?.name
											}}
										</div>
									</div>
									<div class="p-4 border-t border-orange-100">
										<div
											v-if="
												assessment?.assessment_report
													?.note
											"
											class="
												uppercase
												font-semibold
												text-neutral-400
											"
										>
											Nhận xét
										</div>
										<div class="mt-2">
											{{
												assessment?.assessment_report
													?.note
											}}
										</div>
										<div
											v-if="
												reason(
													assessment?.assessment_report
												)
											"
											class="
												uppercase
												font-semibold
												text-neutral-400
												mt-4
											"
										>
											Album
										</div>
										<div class="mt-2">
											<div>
												<svg
													v-if="
														assessment
															?.assessment_report
															?.has_goal_media
													"
													fill="none"
													height="20"
													viewBox="0 0 20 20"
													width="20"
													xmlns="http://www.w3.org/2000/svg"
												>
													<path
														clip-rule="evenodd"
														d="M15.002 5H2.50195C1.8116 5 1.25195 5.55964 1.25195 6.25V16.25L4.56001 13.3081C4.77068 13.0974 5.10075 13.0647 5.34864 13.23L8.67232 15.4458L13.31 10.8081C13.5002 10.6179 13.7908 10.5707 14.0315 10.691L16.252 13.125V6.25C16.252 5.55964 15.6923 5 15.002 5ZM2.50195 3.75C1.12124 3.75 0.00195312 4.86929 0.00195312 6.25V16.25C0.00195312 17.6307 1.12124 18.75 2.50195 18.75H15.002C16.3827 18.75 17.502 17.6307 17.502 16.25V6.25C17.502 4.86929 16.3827 3.75 15.002 3.75H2.50195ZM7.50195 9.375C7.50195 10.4105 6.66249 11.25 5.62695 11.25C4.59142 11.25 3.75195 10.4105 3.75195 9.375C3.75195 8.33947 4.59142 7.5 5.62695 7.5C6.66249 7.5 7.50195 8.33947 7.50195 9.375Z"
														fill="#E5A42B"
														fill-rule="evenodd"
													/>
													<path
														clip-rule="evenodd"
														d="M4.5 2.25H18C18.5523 2.25 19 2.69772 19 3.25V14.25C19 14.8023 18.5523 15.25 18 15.25H17.5V16.25H18C19.1046 16.25 20 15.3546 20 14.25V3.25C20 2.14543 19.1046 1.25 18 1.25H4.5C3.39543 1.25 2.5 2.14543 2.5 3.25V3.75H3.5V3.25C3.5 2.69772 3.94772 2.25 4.5 2.25Z"
														fill="#E5A42B"
														fill-rule="evenodd"
													/>
												</svg>
												<div v-else>-</div>
											</div>
										</div>
										<div
											v-if="
												reason(
													assessment?.assessment_report
												)
											"
											class="
												uppercase
												font-semibold
												text-neutral-400
												mt-4
											"
										>
											Đánh giá
										</div>
										<div
											v-if="
												reason(
													assessment?.assessment_report
												)
											"
											class="mt-2"
										>
											{{
												reason(
													assessment?.assessment_report
												)
											}}
										</div>
										<div
											v-if="
												assessment?.assessment_report
													?.result
											"
											class="
												uppercase
												font-semibold
												text-neutral-400
												mt-4
											"
										>
											Kết quả
										</div>
										<div
											v-if="
												assessment?.assessment_report
													?.result
											"
											:style="{
												background: $filters.tagResult(
													assessment
														?.assessment_report
														?.result
												)?.background,
												color: $filters.tagResult(
													assessment
														?.assessment_report
														?.result
												)?.color,
											}"
											class="
												mt-2
												mb-4
												py-0.5
												px-2.5
												rounded-full
												text-neutral-700
												h-fit
												w-fit
												font-semibold
												text-xs
												shadow-input
											"
										>
											{{
												assessment?.assessment_report
													?.result
											}}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div v-if="step === 3 && editReport">
					<!--      Make report step 3 component-->
					<MakeReportStep3
						:key="report.id"
						:inserted-at="monthly_start"
						:report-id="report.id"
						:report-order="report.next_plan_order"
						@isDone="isDone = true"
						@isNoteDone="isDone = false"
						@submit="submit"
					/>
					<!--      Make report step 3 component-->
				</div>
			</div>
		</div>
		<div v-else class="fixed top-1/2 left-1/2">
			<Loading />
		</div>
	</div>
</template>

<script setup>
import { $api } from '@/services';
import { computed, onMounted, ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { _MODAL_TYPE, _ROUTER_NAME } from '@/enums';
import DaModalFrame from '@/components/common/daModalFrame/DaModalFrame.vue';
import ConfirmModal from '@/views/report/features/monthlyReport/features/confirmModal/ConfirmModal.vue';
import { _GET_DATE_2 } from '@/helper/formatDate';
import CopyModal from '@/views/report/features/copyModal/CopyModal.vue';
import ExitModal from '@/views/report/features/monthlyReport/features/exitConfirm/ExitModal.vue';
import DaIcon from '@/components/elements/daIcon/DaIcon.vue';
import MakeReportStep3 from '@/components/modules/monthlyReport/MakeReportStep3.vue';
import ErrorModal from '@/views/report/features/monthlyReport/features/errorModal/ErrorModal.vue';
import DownloadCSV from '@/mixins/downloadCSV.vue';
import ConfirmSendMonthlyReport from '@/views/report/features/monthlyReport/features/ConfirmSendMonthlyReport/ConfirmSendMonthlyReport.vue';
import Loading from '@/components/common/Loading.vue';
import { _MONTH_DIFF } from '@/helper/monthDiff';
import dayjs from 'dayjs';
import LoadingDowloadPDF from '@/views/plansDetail/features/reportTarget/loadingDowloadPDF/loadingDowloadPDF.vue';
import NoteSlide from './features/noteSlide/noteSlide.vue';
import Goal from './features/goal/Goal.vue';

const route = useRoute();
const router = useRouter();
const store = useStore();
const step = ref(1);
const id = ref(route.params.id);
const monthly_start = ref(route.query.month_start);
const goalSelectedId = ref(route.query.goal);
const sideOverShow = ref(false);
const report = ref(null);
const skills = ref(null);
const skillsShow = ref(null);
const all_goals_reported = ref(false);
const alertShow = ref(true);
const isLoading = ref(true);
const listVideo = ref([]);
const errorData = ref({
	error: '',
	reportError: [],
});
const tabs = ref([
	{
		name: 'Nội dung báo cáo',
		value: 0,
	},
	{
		name: 'Video từ phụ huynh',
		value: 1,
	},
]);
const tabSelected = ref(0);
const is_old_data = computed(() => route.query.is_old_data);
const enableSessionCount = computed(
	() =>
		store.state.profile.current_org.enable_session_count_for_monthly_report
);
const chartOptions3 = ref({
	colors: ['#9EDF93', '#D0DB54', '#FFE68C', '#FF9D6D', '#FF6967'],
	chart: {
		width: 380,
		type: 'polarArea',
	},
	labels: ['Vui vẻ', 'Bình thường', 'Khó chịu', 'Tức giận', 'Bùng nổ'],
	fill: {
		opacity: 1,
		colors: ['#9EDF93', '#D0DB54', '#FFE68C', '#FF9D6D', '#FF6967'],
	},
	stroke: {
		lineCap: 'round',
	},
	yaxis: {
		show: false,
	},
	tooltip: {
		fillSeriesColor: true,
		y: {
			formatter: function (value) {
				if (!value || value == 'null') {
					return 'Không thực hiện';
				}
				return value + '%';
			},
		},
	},
	legend: {
		show: false,
	},
	dataLabels: {
		enabled: false,
	},
	plotOptions: {
		polarArea: {
			rings: {
				strokeWidth: 0,
			},
			spokes: {
				strokeWidth: 0,
			},
		},
	},
});
const mixChartOptions = ref({
	chart: {
		type: 'line',
		stacked: false,
	},
	dataLabels: {
		enabled: true,
		enabledOnSeries: [0, 1],
		offsetY: -10,
		background: {
			enabled: true,
			foreColor: '#334155',
		},
		formatter: function (val) {
			return val + '%';
		},
	},
	stroke: {
		width: [0.5, 0.5, 4],
	},
	yaxis: [
		{
			opposite: false,
			axisTicks: {
				show: false,
			},
			axisBorder: {
				show: false,
			},
			labels: {
				show: false,
				formatter: function (value) {
					if (!value || value == 'null') {
						return 'Không thực hiện';
					}
					return value + '%';
				},
			},
			title: {
				show: false,
			},
			max: 100,
		},
		{
			opposite: false,
			axisTicks: {
				show: false,
			},
			axisBorder: {
				show: false,
			},
			labels: {
				show: false,
				formatter: function (value) {
					if (!value || value == 'null') {
						return 'Không thực hiện';
					}
					return value + '%';
				},
			},
			title: {
				show: false,
			},
			max: 100,
		},
		{
			opposite: false,
			axisTicks: {
				show: false,
			},
			axisBorder: {
				show: false,
			},
			labels: {
				show: false,
				formatter: function (value) {
					if (!value || value == 'null') {
						return 'Không thực hiện';
					}
					return value + '%';
				},
			},
			title: {
				show: false,
			},
			max: 100,
		},
	],
	tooltip: {
		fixed: {
			enabled: true,
			position: 'topLeft', // topRight, topLeft, bottomRight, bottomLeft
			offsetY: 30,
			offsetX: 60,
		},
	},
	legend: {
		horizontalAlign: 'left',
		offsetX: 40,
	},
	plotOptions: {
		bar: {
			horizontal: false,
			columnWidth: '20%',
			borderRadius: 4,
		},
	},
	labels: [],
	colors: ['#FFD270', '#DA8F8F', '#6ED0B9'],
	markers: {
		size: 8,
		strokeColors: '#fff',
		strokeWidth: 2,
	},
});
const mixChartOptions2 = ref({
	chart: {
		type: 'line',
		stacked: false,
	},
	dataLabels: {
		enabled: true,
		enabledOnSeries: [0, 1],
		offsetY: -10,
		background: {
			enabled: true,
			foreColor: '#334155',
		},
		formatter: function (val) {
			return val + '%';
		},
	},
	stroke: {
		width: [0.5, 0.5],
	},
	yaxis: [
		{
			opposite: false,
			axisTicks: {
				show: false,
			},
			axisBorder: {
				show: false,
			},
			labels: {
				show: false,
				formatter: function (value) {
					if (!value || value == 'null') {
						return 'Không thực hiện';
					}
					return value + '%';
				},
			},
			title: {
				show: false,
			},
			max: 100,
		},
		{
			opposite: false,
			axisTicks: {
				show: false,
			},
			axisBorder: {
				show: false,
			},
			labels: {
				show: false,
				formatter: function (value) {
					if (!value || value == 'null') {
						return 'Không thực hiện';
					}
					return value + '%';
				},
			},
			title: {
				show: false,
			},
			max: 100,
		},
	],
	xaxis: {
		categories: [],
	},
	tooltip: {
		fixed: {
			enabled: true,
			position: 'topLeft', // topRight, topLeft, bottomRight, bottomLeft
			offsetY: 30,
			offsetX: 60,
		},
	},
	legend: {
		horizontalAlign: 'left',
		offsetX: 40,
	},
	plotOptions: {
		bar: {
			horizontal: false,
			columnWidth: '10%',
			borderRadius: 4,
			distributed: false,
		},
	},
	labels: [],
	colors: ['#F59E0B', '#2AA797'],
	markers: {
		size: 8,
		strokeColors: '#fff',
		strokeWidth: 2,
	},
});
const modalTypes = computed(() => _MODAL_TYPE);
const chartOptions = ref({
	dataLabels: {
		enabled: false,
	},
	colors: ['#7AD2C6', '#93BF56', '#F8BB54', '#F47C7C', '#E5E7EB'],
	labels: [
		'Đạt 80 - 100%',
		'Đạt 55 - 75%',
		'Đạt 30 - 50%',
		'Đạt 5 - 25%',
		'X',
	],
	legend: {
		show: false,
	},
	tooltip: {
		fillSeriesColor: true,
		y: {
			formatter: function (value) {
				return value + ' mục tiêu';
			},
		},
	},
	stroke: {
		lineCap: 'round',
	},
});
const chartOptions2_1 = ref({
	chart: {
		type: 'radialBar',
	},
	plotOptions: {
		radialBar: {
			hollow: {
				size: '54%',
			},
			dataLabels: {
				name: {
					offsetY: -10,
					show: true,
					color: '#65758B',
					fontWeight: 'normal',
					fontSize: '13px',
				},
				value: {
					color: '#48566A',
					fontSize: '24px',
					show: true,
					fontWeight: 'bold',
				},
			},
		},
	},
	fill: {
		colors: '#6ED0B9',
	},
	stroke: {
		lineCap: 'round',
	},
	labels: ['Kết quả'],
});
const chartOptions2_2 = ref({
	chart: {
		type: 'radialBar',
	},
	plotOptions: {
		radialBar: {
			hollow: {
				size: '54%',
			},
			dataLabels: {
				name: {
					offsetY: -10,
					show: true,
					color: '#65758B',
					fontWeight: 'normal',
					fontSize: '13px',
				},
				value: {
					color: '#48566A',
					fontSize: '24px',
					show: true,
					fontWeight: 'bold',
				},
			},
		},
	},
	fill: {
		colors: '#FFD270',
	},
	stroke: {
		lineCap: 'round',
	},
	labels: ['Sự tham gia'],
});
const chartOptions2_3 = ref({
	chart: {
		type: 'radialBar',
	},
	plotOptions: {
		radialBar: {
			hollow: {
				size: '54%',
			},
			dataLabels: {
				name: {
					offsetY: -10,
					show: true,
					color: '#65758B',
					fontWeight: 'normal',
					fontSize: '13px',
					fontFamily: 'SVN-Gilroy',
				},
				value: {
					color: '#48566A',
					fontSize: '24px',
					show: true,
					fontWeight: 'bold',
				},
			},
		},
	},
	fill: {
		colors: '#DA8F8F',
	},
	stroke: {
		lineCap: 'round',
	},
	labels: ['Cảm xúc'],
});
const editQuery = route.query.action === 'edit' ? true : '';
let editReport = ref(editQuery);
let org = ref({
	value: {
		note: '',
	},
});
let assessment_result = ref([]);
let assessment_report_next_plan = ref(null);
let series = ref([]);
let series3 = ref([]);
let radarData = ref([]);
let categories = ref([]);
const radarChartOptions = ref({
	chart: {
		id: 'radarChart',
		type: 'radar',
	},
	title: {
		show: false,
	},
	stroke: {
		width: 0,
	},
	fill: {
		opacity: 0.2,
		colors: ['#65A30D'],
	},
	markers: {
		size: 5,
		hover: {
			size: 10,
		},
		colors: ['#65A30D'],
	},
	dataLabels: {
		enabled: true,
		formatter: function (val) {
			return val + '%';
		},
		style: {
			fontFamily: 'Gilrory',
			fontSize: '20px',
			fontWeight: 'bold',
			colors: ['#344256'],
		},
		background: {
			enabled: false,
		},
	},
	yaxis: {
		show: false,
		logBase: 100,
		tickAmount: 10,
		min: 0,
		max: 100,
		labels: {
			show: false,
		},
	},
	xaxis: {
		categories: [],
		labels: {
			show: true,
			style: {
				fontFamily: 'Gilrory',
				fontSize: '14px',
				fontWeight: 600,
				colors: Array(1000).fill('#344256'),
			},
			formatter: function (val, index) {
				return index?.dataPointIndex + 1;
			},
		},
	},
	tooltip: {
		x: {
			show: true,
			formatter: function (val, object) {
				return `${object?.dataPointIndex + 1}: ${val}`;
			},
			title: {
				formatter: (seriesName) => seriesName,
			},
		},
		y: {
			show: true,
			formatter: function (val) {
				return val + '%';
			},
			title: {
				title: {
					formatter: (seriesName) => seriesName + ':',
				},
			},
		},
	},
});
let emotion_scale = ref([]);
let assessments_by_skill = ref([]);
let series3Total = ref(0);
const compare_with_last = ref({
	average_cooperation_scale: '0.0',
	average_emotion_scale: '0.0',
	average_result: '0.0',
});
const attendance = ref({
	attendance_compare_with_last_percent: '0.0',
	attendance_percent: '100.0',
	completed: 2,
	total: 2,
});
let noteContent = ref('');
let noteUpdateError = ref('');
let successData = ref(false);
let modalIsOpen = ref(false);
let modalType = ref('');
let plan = ref(null);
let emotion_cooperation_result_by_day = ref([]);
let emotion_cooperation_result_by_day_emotion = ref([]);
let emotion_cooperation_result_by_day_rating = ref([]);
let emotion_cooperation_result_by_day_result = ref([]);
let emotion_cooperation_result_by_day_labels = ref([]);
let emotion_cooperation_result_by_day_data = ref([
	{
		name: 'Cảm xúc',
		type: 'column',
		data: [0, 0, 0, 0, 0],
	},
	{
		name: 'Sự tham gia',
		type: 'column',
		data: [0, 0, 0, 0, 0],
	},
	{
		name: 'Kết quả buổi học',
		type: 'line',
		data: [0, 0, 0, 0, 0],
	},
]);
let emotion_cooperation_result_by_day_data2 = ref([
	{
		name: 'Tháng 12/2023',
		type: 'column',
		data: [0, 0, 0, 0, 0],
	},
	{
		name: 'Tháng 12/2023',
		type: 'column',
		data: [0, 0, 0, 0, 0],
	},
]);
const mixChart = ref(null);
const mixChart2 = ref(null);
const stats = ref({
	total_goal_count: 0,
	total_skill_count: 0,
});
const path = ref('');
const listAssessment = ref([]);
const isDone = ref(false);
const dateData = computed(() => {
	const join_date = route.query.join_date;
	const left_date = route.query.left_date;
	if (!join_date) {
		return '';
	}
	return `${_GET_DATE_2(join_date)} - ${
		left_date ? _GET_DATE_2(left_date) : 'Hiện tại'
	} | Đã học ${_MONTH_DIFF(join_date, left_date)} tháng`;
});

const goalNote = ref('');
const nextPlan = ref('');

const isAdmin = computed(() => store.getters.isAdmin);

watch(
	mixChart,
	() => {
		const optimalColumnWidthPercent =
			5 +
			15 /
				(1 +
					30 *
						Math.exp(
							-emotion_cooperation_result_by_day_labels.value
								?.length / 3
						));

		setTimeout(() => {
			mixChart.value?.updateOptions({
				labels: emotion_cooperation_result_by_day_labels.value,
				plotOptions: {
					bar: {
						columnWidth: optimalColumnWidthPercent + '%',
					},
				},
			});
		}, 1000);
	},
	{ immediate: true, deep: true }
);

watch(
	mixChart2,
	() => {
		const optimalColumnWidthPercent =
			12 + 16 / (1 + 30 * Math.exp(-categories.value?.length / 3));

		setTimeout(() => {
			mixChart2.value?.updateOptions({
				labels: categories.value,
				plotOptions: {
					bar: {
						columnWidth: optimalColumnWidthPercent + '%',
					},
				},
			});
		}, 1000);
	},
	{ immediate: true, deep: true }
);

watch(
	editReport,
	(value) => {
		if (value) {
			const queryRoute = Object.assign({}, route.query);
			queryRoute.action = 'edit';
			router.push({
				query: queryRoute,
			});
		}
	},
	{ immediate: true }
);

watch(route, (value) => {
	editReport.value = value.query.action === 'edit' ? true : '';
});

onMounted(() => {
	window.scrollTo(0, 0);
	fetchReport();
});

function edit() {
	step.value = 1;
	editReport.value = true;
	noteContent.value = report.value?.note;
}

async function submit(data, isUpdate) {
	plan.value = data;
	reportData.value = {
		student: computed(() => report.value?.student?.full_name),

		monthly_start: computed(() => monthly_start.value),

		inserted_at: computed(() => report.value?.completed_at),
		staff: computed(
			() => monthly_start.value?.submitted_by_staff?.full_name
		),
		report_name: `KẾ HOẠCH ${report.value?.report_for_plan?.order}`,
		report_name_next: `KẾ HOẠCH CAN THIỆP ${report.value?.next_plan_order}`,
		report_date: plan.value?.apply_at,
	};
	successData.value = false;
	if (noteContent.value?.length <= 0) {
		return (noteUpdateError.value =
			'Bạn cần hoàn tất nhận xét chung của tháng để hoàn thành báo cáo');
	}

	if (isUpdate) {
		await confirmSubmit();
		return;
	}
	modalIsOpen.value = true;
	modalType.value = _MODAL_TYPE.CONFIRM;
}

async function getVideo(month_start, month_end) {
	try {
		const res = await $api.student.getVideoFromParents(id.value, {
			month_start: month_start,
			month_end: month_end,
		});
		listVideo.value = res.data.data;
	} catch (err) {
		await store.dispatch('setAlertMessage', {
			message: 'Đã có lỗi xảy ra. Vui lòng thử lại',
			type: 'danger',
		});
	} finally {
		isLoading.value = false;
	}
}
async function fetchReport() {
	try {
		emotion_cooperation_result_by_day.value = [];
		emotion_cooperation_result_by_day_emotion.value = [];
		emotion_cooperation_result_by_day_rating.value = [];
		emotion_cooperation_result_by_day_result.value = [];
		emotion_cooperation_result_by_day_labels.value = [];
		emotion_cooperation_result_by_day_data.value = [
			{
				name: 'Kết quả buổi học',
				type: 'line',
				data: [0, 0, 0, 0, 0],
			},
			{
				name: 'Sự tham gia',
				type: 'column',
				data: [0, 0, 0, 0, 0],
			},
			{
				name: 'Cảm xúc',
				type: 'column',
				data: [0, 0, 0, 0, 0],
			},
		];
		emotion_cooperation_result_by_day_data2.value = [
			{
				name: 'Tháng 12/2023',
				type: 'column',
				data: [0, 0, 0, 0, 0],
			},
			{
				name: 'Tháng 01/2024',
				type: 'column',
				data: [0, 0, 0, 0, 0],
			},
		];
		const oldPayload = ref({
			'x-cross': route.query.org_id,
		});

		const { data } = await $api.monthlyReport.monthlyReport(
			id.value,
			monthly_start.value,
			is_old_data.value ? oldPayload.value : null
		);
		skillsShow.value = data?.skills ?? [];
		if (data) {
			if (!data?.data?.id) {
				return createReport();
			}

			report.value = data.data;
			noteContent.value = report.value.note;
			fetchListGoalAssignment(true);
			if (report.value.report_for_plan && !route.query) {
				await getVideo(
					report.value?.report_for_plan?.applied_at,
					report.value?.report_for_plan?.done_at
				);
			}
			if (data?.org) {
				org.value = data?.org;
			}
			if (data?.stats) {
				stats.value = data.stats;

				if (data?.stats.compare_with_last) {
					compare_with_last.value = data?.stats.compare_with_last;
				}

				if (data?.stats.attendance) {
					attendance.value = data?.stats.attendance;
				}

				if (data?.stats.assessment_report_next_plan) {
					assessment_report_next_plan.value =
						data?.stats.assessment_report_next_plan;
				}
			}
			if (data?.stats?.assessment_results) {
				assessment_result.value = data?.stats?.result;
				emotion_cooperation_result_by_day.value =
					data?.stats?.emotion_cooperation_result_by_day;
				assessments_by_skill.value = data?.stats?.assessment_results;
				emotion_scale.value = data?.stats?.emotion_scale;
				emotion_scale.value.forEach((item) => {
					return (series3Total.value += item.count);
				});
				series3.value = emotion_scale.value.map((item) => {
					const r = (item.count * 100) / series3Total.value;
					return Math.round(r * 10) / 10 || 0;
				});
				let a = [];
				let count = 0;
				assessment_result.value.forEach((item) => {
					if (
						item.result === 'Từ chối' ||
						item.result === 'Không có cơ hội' ||
						item.result === 'Không hợp tác'
					) {
						count += item.count;
					} else {
						a.push(item);
					}
				});
				a.push({
					result: 'X',
					count: count,
				});
				series.value = a.map((item) => {
					return item.count;
				});
				emotion_cooperation_result_by_day.value.forEach((item) => {
					emotion_cooperation_result_by_day_emotion.value.push(
						+(+item.emotion_scale / 5) * 100 || null
					);
					emotion_cooperation_result_by_day_rating.value.push(
						+(+item.cooperation_scale / 5) * 100 || null
					);
					emotion_cooperation_result_by_day_result.value.push(
						+item.complete_percent || null
					);

					emotion_cooperation_result_by_day_labels.value.push(
						_GET_DATE_2(item.date, true)
					);
				});
				emotion_cooperation_result_by_day_data.value[1] = {
					name: 'Cảm xúc',
					type: 'column',
					data: emotion_cooperation_result_by_day_emotion.value,
				};
				emotion_cooperation_result_by_day_data.value[0] = {
					name: 'Sự tham gia',
					type: 'column',
					data: emotion_cooperation_result_by_day_rating.value,
				};
				emotion_cooperation_result_by_day_data.value[2] = {
					name: 'Kết quả buổi học',
					type: 'line',
					data: emotion_cooperation_result_by_day_result.value,
				};
			}
			if (data.skills) {
				radarData.value = [
					{
						name: 'Kết quả',
						data: data.skills.map((skill) => {
							return skill?.skill?.skill_percent;
						}),
					},
				];
				radarChartOptions.value.xaxis.categories = data.skills.map(
					(skill) => {
						return skill?.skill?.name;
					}
				);
				categories.value = data.skills.map((skill) => {
					return skill?.skill?.name;
				});
				emotion_cooperation_result_by_day_data2.value[1] = {
					name: `Tháng ${dayjs(data?.data.apply_date).format(
						'MM/YYYY'
					)}`,
					type: 'column',
					data: data?.skills?.map(
						(s) => +s.skill?.skill_percent || 0
					),
				};
			}
			if (data?.previous_month_skills) {
				const previous_month_skills = [];
				data?.skills.forEach((item) => {
					const o = data?.previous_month_skills?.find(
						(s) => s.skill.id === item.skill.id
					);
					if (o) {
						previous_month_skills.push(
							+o.skill?.skill_percent || 0
						);
					} else {
						previous_month_skills.push(0);
					}
				});
				emotion_cooperation_result_by_day_data2.value[0] = {
					name: `Tháng ${dayjs(data?.previous_month_start).format(
						'MM/YYYY'
					)}`,
					type: 'column',
					data: previous_month_skills,
				};
			}
		}
	} catch (e) {
		console.log(e);
	} finally {
		isLoading.value = false;
	}
}

async function createReport() {
	try {
		await $api.monthlyReport.createMonthlyReport(id.value, {
			month_start: monthly_start.value,
		});
		await fetchReport();
	} catch (e) {
		console.log(e);
	}
}

async function fetchListGoalAssignment(firstAccess) {
	try {
		const res = firstAccess
			? await $api.monthlyReport.generateListAssessmentReports(
					id.value,
					report.value.id
			  )
			: await $api.monthlyReport.listAssessmentReports(
					id.value,
					report.value.id
			  );

		if (res.data.data?.goals_group_by_skill)
			listAssessment.value = res.data.data?.goals_group_by_skill;
		else listAssessment.value = res.data.data;
		all_goals_reported.value = res.data?.all_goals_reported;
	} catch (e) {
		const error =
			e?.response?.data?.errors.join('<br/>') || 'Đã có lỗi xảy ra';
		await store.dispatch('setAlertMessage', {
			message: error,
			type: 'danger',
		});
	}
}

function addNoteForGoal(value) {
	goalSelectedId.value = value?.goal_id || value.id;
	sideOverShow.value = true;
}

function submitNote() {
	sideOverShow.value = false;
	fetchListGoalAssignment(false);
}

function exit() {
	modalIsOpen.value = true;
	modalType.value = _MODAL_TYPE.EXIT;
}

function openSendConfirm() {
	modalIsOpen.value = true;
	modalType.value = _MODAL_TYPE.CREATE;
}

function cancelSendReport() {
	modalIsOpen.value = false;
	modalType.value = '';
}

async function sendReport() {
	try {
		await $api.monthlyReport.sendMonthlyReport(id.value, report.value?.id);
		cancelSendReport();
		await fetchReport();
		await store.dispatch('setAlertMessage', {
			message: 'Gửi kế hoạch đến phụ huynh thành công',
		});
	} catch (err) {
		await store.dispatch('setAlertMessage', {
			message: 'Đã có lỗi xảy ra. Vui lòng thử lại',
			type: 'danger',
		});
	}
}

function cancel() {
	editReport.value = false;
	noteContent.value = '';
	noteUpdateError.value = '';
	modalIsOpen.value = false;
	modalType.value = '';
	path.value = ' ';
	router.push('/report/monthly-report');
}

function doNextPlan() {
	router.push(`/plans/${id.value}/future`);
}

async function confirmSubmit() {
	try {
		const isUpdate = report.value?.state === 'completed';
		const res = isUpdate
			? await $api.monthlyReport.updateNoteReport(
					report.value.id,
					id.value,
					{
						monthly_report: {
							note: noteContent.value,
						},
					}
			  )
			: await $api.monthlyReport.submitReport(report.value.id, id.value, {
					monthly_report: {
						note: noteContent.value,
					},
					plan: {
						apply_now: plan.value?.apply_now || false,
						name: plan.value?.name || '',
						apply_date: plan.value?.apply_at || '',
					},
			  });
		if (res?.data) {
			successData.value = true;
			await router.push(
				`/report/monthly-report/${id.value}?month_start=${monthly_start.value}`
			);
			await store.dispatch('setAlertMessage', {
				message: isUpdate
					? 'Báo cáo đã được cập nhật thành công'
					: 'Làm báo cáo thành công',
			});
			await fetchReport();
		}
	} catch (e) {
		modalIsOpen.value = true;
		modalType.value = _MODAL_TYPE.ERROR;
		errorData.value = {
			error: e.response.data?.errors.join('<br />') || 'Đã có lỗi xảy ra',
			reportError: e.response.data?.data || [],
		};
	}
}

function cancelConfirm() {
	modalIsOpen.value = false;
}

function cancelConfirmCompleted() {
	editReport.value = false;
	noteContent.value = '';
	noteUpdateError.value = '';
	modalIsOpen.value = false;
	modalType.value = '';
	path.value = ' ';
	modalIsOpen.value = false;
}

let reportData = ref({
	student: computed(() => report.value?.student?.full_name),
	monthly_start: computed(() => monthly_start.value),

	inserted_at: computed(() => report.value?.completed_at),
	staff: computed(() => monthly_start.value?.submitted_by_staff?.full_name),
	reportName: report.value?.next_plan_order,
	report_date: plan.value?.apply_at,
});

function reason(as) {
	const stopped_reason = as?.stopped_reason
		? as?.stopped_reason.toLowerCase()
		: '';
	const stopped_reason_other = as?.stopped_reason_other || '';
	const other =
		stopped_reason !== 'Khác' && stopped_reason !== 'other'
			? stopped_reason
			: stopped_reason_other;
	return as?.next_plan !== 'Tạm dừng mục tiêu'
		? as?.next_plan
		: `${as?.next_plan} ${other ? ' vì ' + other : ''}`;
}

// function countComplete(s) {
// 	let count = 0;
// 	s.goals.forEach((goal) => {
// 		if (goal.completed) {
// 			count++;
// 		}
// 	});
// 	return count;
// }

async function downloadPDF() {
	try {
		modalIsOpen.value = true;
		modalType.value = _MODAL_TYPE.LOADING;
		const url =
			process.env.VUE_APP_PDF_URL +
			'report/monthly-report/' +
			id.value +
			'?token=' +
			localStorage.getItem('tk') +
			'&subdomain=' +
			localStorage.getItem('sub-domain') +
			'&month_start=' +
			monthly_start.value;
		const params = {
			url: url,
			format: 'a2',
			id_render: 'monthly_report_pdf',
		};
		const response = await fetch(
			'https://g4ridpplxi.execute-api.ap-southeast-1.amazonaws.com/',
			{
				method: 'POST',
				body: JSON.stringify(params),
				headers: {
					Accept: 'application/json',
					'Content-Type': 'application/json',
				},
			}
		);
		if (!response.ok) {
			cancelConfirm();
			return;
		}
		const data = await response.json();
		if (data.data) {
			cancelConfirm();
			const linkSource = `data:application/pdf;base64, ${data.data}`;
			const link = document.createElement('a');
			const fileName = 'BaoCaoThang.pdf';
			link.href = linkSource;
			link.download = fileName;
			link.click();
		}
	} catch (e) {
		cancelConfirm();
		await store.dispatch('setAlertMessage', {
			message:
				e?.response?.data?.errors?.join('<br/>') ||
				'Đã có lỗi xảy ra. Vui lòng thử lại',
			type: 'danger',
		});
		console.log(e);
	}
}
const saveNoteContent = async () => {
	try {
		await $api.monthlyReport.saveNoteContent(
			id.value,
			report.value.id,
			noteContent.value
		);
		await store.dispatch('setAlertMessage', {
			message: 'Lưu nhận xét thành công',
		});
	} catch (e) {
		console.log(e);
		await store.dispatch('setAlertMessage', {
			message:
				e?.response?.data?.errors?.join('<br/>') ||
				'Đã có lỗi xảy ra. Vui lòng thử lại',
			type: 'danger',
		});
	}
};

const submitNoteContent = (data) => {
	noteContent.value = data;
	sideOverShow.value = false;
	saveNoteContent();
};

const exportCSV = (studentId, reportId) => {
	DownloadCSV.methods.downloadCSVPlanReport(studentId, reportId);
};
</script>
<style lang="scss" scoped>
@import '../../../../assets/styles/responsive';

.transition {
	transition: all 0.4s ease;
}

.content-report-is-hide {
	@include media-breakpoint-up(lg) {
		padding-right: 40px;
	}
}

.tab {
	padding: 8px 12px 16px 12px;
	color: #48566a;
	font-size: 16px;
	font-weight: 400;
	line-height: 24px;
}

.tab-selected {
	color: #e5a42b;
	border-bottom: 2px solid #e5a42b;
}

.video {
	width: 400px;
	height: 215px;
}
@media only screen and (min-width: 768px) {
	.w-custom {
		width: calc((100% - 460px) / 2) !important;
	}
}
@media only screen and (max-width: 767px) {
	.w-custom {
		width: 300px !important;
	}
}

.w-186 {
	width: 186px !important;
}
</style>
